{
  "selectedBranch": "prod",
  "branches": {
    "items": [
      {
        "id": "prod",
        "description": "Update entry [__acldefault__] of document [aclprofiles]",
        "date": "2020-11-10T15:49:17+02:00",
        "logs": [
          {
            "version": "7dd9580c00bef1049ee9a531afb13db9ef3ee956",
            "date": "2020-11-10T15:49:17+02:00",
            "parents": ["fc47a6cd9d7f254dd97875a04b87165cc484e075"],
            "message": "Update entry [__acldefault__] of document [aclprofiles]",
            "email": "curiefense@link11.com",
            "author": "Curiefense API"
          },
          {
            "version": "fc47a6cd9d7f254dd97875a04b87165cc484e075",
            "date": "2020-11-10T15:48:35+02:00",
            "parents": ["5aba4a5b9d6faea1896ee8965c7aa651f76af63c"],
            "message": "Update entry [__acldefault__] of document [aclprofiles]",
            "email": "curiefense@link11.com",
            "author": "Curiefense API"
          },
          {
            "version": "5aba4a5b9d6faea1896ee8965c7aa651f76af63c",
            "date": "2020-11-10T15:48:31+02:00",
            "parents": ["277c5d7bd0e2eb4b9d2944f7eefdfadf37ba8581"],
            "message": "Update entry [__acldefault__] of document [aclprofiles]",
            "email": "curiefense@link11.com",
            "author": "Curiefense API"
          },
          {
            "version": "277c5d7bd0e2eb4b9d2944f7eefdfadf37ba8581",
            "date": "2020-11-10T15:48:22+02:00",
            "parents": ["878b47deeddac94625fe7c759786f2df885ec541"],
            "message": "Update entry [__acldefault__] of document [aclprofiles]",
            "email": "curiefense@link11.com",
            "author": "Curiefense API"
          },
          {
            "version": "878b47deeddac94625fe7c759786f2df885ec541",
            "date": "2020-11-10T15:48:05+02:00",
            "parents": ["93c180513fe7edeaf1c0ca69a67aa2a11374da4f"],
            "message": "Update entry [__acldefault__] of document [aclprofiles]",
            "email": "curiefense@link11.com",
            "author": "Curiefense API"
          },
          {
            "version": "93c180513fe7edeaf1c0ca69a67aa2a11374da4f",
            "date": "2020-11-10T15:47:59+02:00",
            "parents": ["1662043d2a18d6ad2c9c94d6f826593ff5506354"],
            "message": "Update entry [__acldefault__] of document [aclprofiles]",
            "email": "curiefense@link11.com",
            "author": "Curiefense API"
          },
          {
            "version": "1662043d2a18d6ad2c9c94d6f826593ff5506354",
            "date": "2020-11-08T21:31:41+01:00",
            "parents": ["16379cdf39501574b4a2f5a227b82a4454884b84"],
            "message": "Create config [prod]\n",
            "email": "curiefense@link11.com",
            "author": "Curiefense API"
          },
          {
            "version": "16379cdf39501574b4a2f5a227b82a4454884b84",
            "date": "2020-08-27T16:19:06+00:00",
            "parents": ["a34f979217215060861b58b3f270e82580c20efb"],
            "message": "Initial empty config",
            "email": "curiefense@link11.com",
            "author": "Curiefense API"
          },
          {
            "version": "a34f979217215060861b58b3f270e82580c20efb",
            "date": "2020-08-27T16:19:06+00:00",
            "parents": [],
            "message": "Initial empty content",
            "email": "curiefense@link11.com",
            "author": "Curiefense API"
          }
        ],
        "version": "7dd9580c00bef1049ee9a531afb13db9ef3ee956"
      },
      {
        "id": "zzz_branch",
        "description": "Initial empty content",
        "date": "2020-08-27T16:19:06+00:00",
        "logs": [
          {
            "version": "a34f979217215060861b58b3f270e82580c20efb",
            "date": "2020-08-27T16:19:06+00:00",
            "parents": [],
            "message": "Initial empty content",
            "email": "curiefense@link11.com",
            "author": "Curiefense API"
          }
        ],
        "version": "a34f979217215060861b58b3f270e82580c20efb"
      }
    ]
  },
  "asns": {
    "blob": {
      "1": "Level 3 Parent, LLC",
      "2": "University of Delaware",
      "3": "Massachusetts Institute of Technology",
      "4": "University of Southern California",
      "6": "ATOS IT Solutions and Services, Inc.",
      "7": "The Defence Science and Technology Laboratory",
      "8": "Rice University",
      "9": "Carnegie Mellon University"
    },
    "format": "json"
  },
  "countries": {
    "blob": {
      "AD": "Andorra",
      "AE": "United Arab Emirates",
      "AF": "Afghanistan",
      "AG": "Antigua and Barbuda",
      "AI": "Anguilla",
      "AL": "Albania",
      "AM": "Armenia",
      "AO": "Angola",
      "AQ": "Antarctica",
      "AR": "Argentina"
    },
    "format": "json"
  },
  "namespaces": {
    "system": {
      "publishinfo": {
        "buckets": [
          {
            "name": "prod1",
            "url": "file:///bucket/prod"
          },
          {
            "name": "stage",
            "url": "file:///bucket/stage"
          }
        ],
        "branch_buckets": [
          {
            "name": "prod",
            "deployment": true,
            "buckets": ["prod1"]
          },
          {
            "name": "stage",
            "deployment": true,
            "buckets": ["stage"]
          }
        ]
      },
      "user": {
        "cookieName": "X-Token",
        "idleModalEnabled": false,
        "idleReminderTime": 5,
        "idleMaxTime": 10
      },
      "tags": {
        "legitimate": ["allowlist"],
        "malicious": ["blocklist", "spamhaus", "tor"],
        "neutral": ["static-content", "crawler", "curiefense", "api", "all"]
      },
      "schema-validation": {},
      "delete": {},
      "feature-toggle": {
        "ssl-server-to-backend-mtls-certificate": false,
        "ssl-server-to-backend-ca-certificate": false,
        "ssl-client-to-v5-client-ca-certificate": false
      }
    },
    "Delete Namespace": {}
  },
  "dashboardData": {
    "timeline": [
      {
        "array_origin_status_codes": [
          {
            "num_of_requests": 1310,
            "status": 200
          },
          {
            "num_of_requests": 45,
            "status": 400
          },
          {
            "num_of_requests": 32,
            "status": 401
          },
          {
            "num_of_requests": 28,
            "status": 403
          },
          {
            "num_of_requests": 156,
            "status": 404
          },
          {
            "num_of_requests": 12,
            "status": 405
          },
          {
            "num_of_requests": 8,
            "status": 408
          },
          {
            "num_of_requests": 7,
            "status": 410
          },
          {
            "num_of_requests": 3,
            "status": 422
          },
          {
            "num_of_requests": 23,
            "status": 429
          },
          {
            "num_of_requests": 5,
            "status": 451
          },
          {
            "num_of_requests": 18,
            "status": 499
          }
        ],
        "array_status_codes": [
          {
            "num_of_requests": 3,
            "status": 473
          }
        ],
        "num_of_blocked_requests": 3,
        "num_of_challenges": 0,
        "num_of_human_requests": 0,
        "num_of_ip": 10,
        "num_of_origin_blocked_requests": 0,
        "num_of_requests": 1650,
        "num_of_sessions": 10,
        "sum_of_sent_bytes": 1720113,
        "time_period": 1711595880,
        "timeperiod_string": "2024-03-28 03:18:00"
      },
      {
        "array_origin_status_codes": [
          {
            "num_of_requests": 1,
            "status": 117
          },
          {
            "num_of_requests": 133,
            "status": 200
          },
          {
            "num_of_requests": 1,
            "status": 217
          },
          {
            "num_of_requests": 1,
            "status": 317
          },
          {
            "num_of_requests": 22,
            "status": 400
          },
          {
            "num_of_requests": 15,
            "status": 401
          },
          {
            "num_of_requests": 18,
            "status": 403
          },
          {
            "num_of_requests": 89,
            "status": 404
          },
          {
            "num_of_requests": 6,
            "status": 405
          },
          {
            "num_of_requests": 4,
            "status": 408
          },
          {
            "num_of_requests": 3,
            "status": 410
          },
          {
            "num_of_requests": 1,
            "status": 422
          },
          {
            "num_of_requests": 11,
            "status": 429
          },
          {
            "num_of_requests": 2,
            "status": 451
          },
          {
            "num_of_requests": 9,
            "status": 499
          },
          {
            "num_of_requests": 1,
            "status": 517
          }
        ],
        "array_status_codes": [],
        "num_of_blocked_requests": 0,
        "num_of_challenges": 0,
        "num_of_human_requests": 0,
        "num_of_ip": 1,
        "num_of_origin_blocked_requests": 0,
        "num_of_requests": 316,
        "num_of_sessions": 1,
        "sum_of_sent_bytes": 117287,
        "time_period": 1711595940,
        "timeperiod_string": "2024-03-28 03:19:00"
      },
      {
        "array_origin_status_codes": [
          {
            "num_of_requests": 1200,
            "status": 200
          },
          {
            "num_of_requests": 38,
            "status": 400
          },
          {
            "num_of_requests": 27,
            "status": 401
          },
          {
            "num_of_requests": 24,
            "status": 403
          },
          {
            "num_of_requests": 142,
            "status": 404
          },
          {
            "num_of_requests": 10,
            "status": 405
          },
          {
            "num_of_requests": 7,
            "status": 408
          },
          {
            "num_of_requests": 19,
            "status": 429
          },
          {
            "num_of_requests": 4,
            "status": 451
          },
          {
            "num_of_requests": 15,
            "status": 499
          },
          {
            "num_of_requests": 6,
            "status": 410
          },
          {
            "num_of_requests": 2,
            "status": 422
          }
        ],
        "array_status_codes": [
          {
            "num_of_requests": 3,
            "status": 473
          }
        ],
        "num_of_blocked_requests": 3,
        "num_of_challenges": 0,
        "num_of_human_requests": 0,
        "num_of_ip": 10,
        "num_of_origin_blocked_requests": 0,
        "num_of_requests": 1494,
        "num_of_sessions": 10,
        "sum_of_sent_bytes": 1594427,
        "time_period": 1711596060,
        "timeperiod_string": "2024-03-28 03:21:00"
      },
      {
        "array_origin_status_codes": [
          {
            "num_of_requests": 1,
            "status": 117
          },
          {
            "num_of_requests": 64,
            "status": 200
          },
          {
            "num_of_requests": 1,
            "status": 217
          },
          {
            "num_of_requests": 1,
            "status": 317
          },
          {
            "num_of_requests": 12,
            "status": 400
          },
          {
            "num_of_requests": 8,
            "status": 401
          },
          {
            "num_of_requests": 9,
            "status": 403
          },
          {
            "num_of_requests": 45,
            "status": 404
          },
          {
            "num_of_requests": 3,
            "status": 405
          },
          {
            "num_of_requests": 2,
            "status": 408
          },
          {
            "num_of_requests": 2,
            "status": 410
          },
          {
            "num_of_requests": 1,
            "status": 422
          },
          {
            "num_of_requests": 6,
            "status": 429
          },
          {
            "num_of_requests": 1,
            "status": 451
          },
          {
            "num_of_requests": 5,
            "status": 499
          },
          {
            "num_of_requests": 1,
            "status": 517
          }
        ],
        "array_status_codes": [],
        "num_of_blocked_requests": 0,
        "num_of_challenges": 0,
        "num_of_human_requests": 0,
        "num_of_ip": 1,
        "num_of_origin_blocked_requests": 0,
        "num_of_requests": 161,
        "num_of_sessions": 1,
        "sum_of_sent_bytes": 57565,
        "time_period": 1711596120,
        "timeperiod_string": "2024-03-28 03:22:00"
      },
      {
        "array_origin_status_codes": [
          {
            "num_of_requests": 1195,
            "status": 200
          },
          {
            "num_of_requests": 41,
            "status": 400
          },
          {
            "num_of_requests": 29,
            "status": 401
          },
          {
            "num_of_requests": 25,
            "status": 403
          },
          {
            "num_of_requests": 148,
            "status": 404
          },
          {
            "num_of_requests": 11,
            "status": 405
          },
          {
            "num_of_requests": 7,
            "status": 408
          },
          {
            "num_of_requests": 20,
            "status": 429
          },
          {
            "num_of_requests": 4,
            "status": 451
          },
          {
            "num_of_requests": 16,
            "status": 499
          },
          {
            "num_of_requests": 6,
            "status": 410
          },
          {
            "num_of_requests": 2,
            "status": 422
          }
        ],
        "array_status_codes": [
          {
            "num_of_requests": 3,
            "status": 473
          }
        ],
        "num_of_blocked_requests": 3,
        "num_of_challenges": 0,
        "num_of_human_requests": 0,
        "num_of_ip": 10,
        "num_of_origin_blocked_requests": 0,
        "num_of_requests": 1504,
        "num_of_sessions": 10,
        "sum_of_sent_bytes": 1529394,
        "time_period": 1711596240,
        "timeperiod_string": "2024-03-28 03:24:00"
      }
    ],
    "stats": [
      {
        "avg_latency": 0.003505451637471438,
        "hostname": "rbzdevzivg01-gcp-euw3-proxy-prod-6f9b9f94b7-hxpwp",
        "num_of_requests": 1313,
        "sum_of_bandwidth": 21566320,
        "time_period": 1711595880,
        "timeperiod_string": "2024-03-28 03:18:00"
      },
      {
        "avg_latency": 0.01709918840579711,
        "hostname": "rbzdevzivg01-gcp-euw3-proxy-prod-6f9b9f94b7-hxpwp",
        "num_of_requests": 138,
        "sum_of_bandwidth": 1272624,
        "time_period": 1711595940,
        "timeperiod_string": "2024-03-28 03:19:00"
      },
      {
        "avg_latency": 0.0025898221113881976,
        "hostname": "rbzdevzivg01-gcp-euw3-proxy-prod-6f9b9f94b7-hxpwp",
        "num_of_requests": 1203,
        "sum_of_bandwidth": 20048496,
        "time_period": 1711596060,
        "timeperiod_string": "2024-03-28 03:21:00"
      },
      {
        "avg_latency": 0.011068521739130432,
        "hostname": "rbzdevzivg01-gcp-euw3-proxy-prod-6f9b9f94b7-hxpwp",
        "num_of_requests": 69,
        "sum_of_bandwidth": 629688,
        "time_period": 1711596120,
        "timeperiod_string": "2024-03-28 03:22:00"
      },
      {
        "avg_latency": 0.004890827212020031,
        "hostname": "rbzdevzivg01-gcp-euw3-proxy-prod-6f9b9f94b7-hxpwp",
        "num_of_requests": 1198,
        "sum_of_bandwidth": 19019704,
        "time_period": 1711596240,
        "timeperiod_string": "2024-03-28 03:24:00"
      }
    ],
    "topx": [
      {
        "avg_origin_time": 0.0025740238418159745,
        "avg_waap_time": 0.002293710674090467,
        "avg_total_time": 0.004114890427582266,
        "first_asn": "AS1680",
        "first_geo_country": "Israel",
        "first_organization": "Cellcom Fixed Line Communication L.P",
        "key": "Israel",
        "label": "country",
        "max_origin_time": 0.04,
        "max_waap_time": 0.048833999999999995,
        "max_total_time": 0.054,
        "min_origin_time": 0.001,
        "min_waap_time": 0.0010659999999999999,
        "min_total_time": 0.002,
        "num_of_blocked_requests": 0,
        "num_of_bot_requests": 84054,
        "num_of_challenges": 0,
        "num_of_human_requests": 0,
        "num_of_monitored_requests": 72533,
        "num_of_requests": 84054,
        "sum_of_bytes_sent": 116967517,
        "sum_of_request_length": 69188176
      },
      {
        "avg_origin_time": 0.18171717171717178,
        "avg_waap_time": 0.01128745773032122,
        "avg_total_time": 0.16003229791740214,
        "first_asn": "",
        "first_geo_country": "United States",
        "first_organization": "",
        "key": "United States",
        "label": "country",
        "max_origin_time": 60.001,
        "max_waap_time": 0.38643099999999997,
        "max_total_time": 60.019,
        "min_origin_time": 0.001,
        "min_waap_time": 0.00094,
        "min_total_time": 0,
        "num_of_blocked_requests": 1927,
        "num_of_bot_requests": 11332,
        "num_of_challenges": 0,
        "num_of_human_requests": 0,
        "num_of_monitored_requests": 8858,
        "num_of_requests": 11332,
        "sum_of_bytes_sent": 8614591,
        "sum_of_request_length": 3784066
      },
      {
        "avg_origin_time": 0.1671965532286214,
        "avg_waap_time": 0.011555377158034537,
        "avg_total_time": 0.08474328327714782,
        "first_asn": "",
        "first_geo_country": null,
        "first_organization": null,
        "key": "",
        "label": "country",
        "max_origin_time": 60.007,
        "max_waap_time": 0.098452,
        "max_total_time": 60.012,
        "min_origin_time": 0.001,
        "min_waap_time": 0.00112,
        "min_total_time": 0,
        "num_of_blocked_requests": 5205,
        "num_of_bot_requests": 9789,
        "num_of_challenges": 0,
        "num_of_human_requests": 0,
        "num_of_monitored_requests": 8148,
        "num_of_requests": 9789,
        "sum_of_bytes_sent": 5112983,
        "sum_of_request_length": 3874536
      },
      {
        "avg_origin_time": 0.18792423590185117,
        "avg_waap_time": 0.007640529211087425,
        "avg_total_time": 0.19303113006396588,
        "first_asn": "",
        "first_geo_country": "China",
        "first_organization": "",
        "key": "China",
        "label": "country",
        "max_origin_time": 60.002,
        "max_waap_time": 0.071712,
        "max_total_time": 60.012,
        "min_origin_time": 0.001,
        "min_waap_time": 0.000954,
        "min_total_time": 0.001,
        "num_of_blocked_requests": 22,
        "num_of_bot_requests": 2345,
        "num_of_challenges": 0,
        "num_of_human_requests": 0,
        "num_of_monitored_requests": 1690,
        "num_of_requests": 2345,
        "sum_of_bytes_sent": 2041727,
        "sum_of_request_length": 736628
      },
      {
        "avg_origin_time": 0.1389515648286141,
        "avg_waap_time": 0.007279698542274051,
        "avg_total_time": 0.11336501457725948,
        "first_asn": "",
        "first_geo_country": "Canada",
        "first_organization": "",
        "key": "Canada",
        "label": "country",
        "max_origin_time": 60.001,
        "max_waap_time": 0.10027,
        "max_total_time": 60.012,
        "min_origin_time": 0.001,
        "min_waap_time": 0.000979,
        "min_total_time": 0,
        "num_of_blocked_requests": 373,
        "num_of_bot_requests": 1715,
        "num_of_challenges": 0,
        "num_of_human_requests": 0,
        "num_of_monitored_requests": 1455,
        "num_of_requests": 1715,
        "sum_of_bytes_sent": 1247866,
        "sum_of_request_length": 580128
      }
    ]
  },
  "aiManagementData": {
    "timeline": [
      {
        "array_origin_status_codes": [
          {
            "num_of_requests": 2845,
            "status": 200
          }
        ],
        "array_status_codes": [
          {
            "num_of_requests": 142,
            "status": 473
          }
        ],
        "num_of_blocked_requests": 142,
        "num_of_challenges": 0,
        "num_of_human_requests": 0,
        "num_of_ip": 45,
        "num_of_origin_blocked_requests": 0,
        "num_of_requests": 2987,
        "num_of_sessions": 45,
        "sum_of_sent_bytes": 4235890,
        "time_period": 1758818400,
        "timeperiod_string": "2025-09-26 15:00:00"
      },
      {
        "array_origin_status_codes": [
          {
            "num_of_requests": 3124,
            "status": 200
          }
        ],
        "array_status_codes": [
          {
            "num_of_requests": 156,
            "status": 473
          }
        ],
        "num_of_blocked_requests": 156,
        "num_of_challenges": 0,
        "num_of_human_requests": 0,
        "num_of_ip": 52,
        "num_of_origin_blocked_requests": 0,
        "num_of_requests": 3280,
        "num_of_sessions": 52,
        "sum_of_sent_bytes": 4856742,
        "time_period": 1758818700,
        "timeperiod_string": "2025-09-26 15:05:00"
      },
      {
        "array_origin_status_codes": [
          {
            "num_of_requests": 2756,
            "status": 200
          }
        ],
        "array_status_codes": [
          {
            "num_of_requests": 89,
            "status": 473
          }
        ],
        "num_of_blocked_requests": 89,
        "num_of_challenges": 0,
        "num_of_human_requests": 0,
        "num_of_ip": 38,
        "num_of_origin_blocked_requests": 0,
        "num_of_requests": 2845,
        "num_of_sessions": 38,
        "sum_of_sent_bytes": 3967234,
        "time_period": 1758819000,
        "timeperiod_string": "2025-09-26 15:10:00"
      },
      {
        "array_origin_status_codes": [
          {
            "num_of_requests": 4123,
            "status": 200
          }
        ],
        "array_status_codes": [
          {
            "num_of_requests": 203,
            "status": 473
          }
        ],
        "num_of_blocked_requests": 203,
        "num_of_challenges": 0,
        "num_of_human_requests": 0,
        "num_of_ip": 67,
        "num_of_origin_blocked_requests": 0,
        "num_of_requests": 4326,
        "num_of_sessions": 67,
        "sum_of_sent_bytes": 6245678,
        "time_period": 1758819300,
        "timeperiod_string": "2025-09-26 15:15:00"
      },
      {
        "array_origin_status_codes": [
          {
            "num_of_requests": 3567,
            "status": 200
          }
        ],
        "array_status_codes": [
          {
            "num_of_requests": 178,
            "status": 473
          }
        ],
        "num_of_blocked_requests": 178,
        "num_of_challenges": 0,
        "num_of_human_requests": 0,
        "num_of_ip": 58,
        "num_of_origin_blocked_requests": 0,
        "num_of_requests": 3745,
        "num_of_sessions": 58,
        "sum_of_sent_bytes": 5234567,
        "time_period": 1758819600,
        "timeperiod_string": "2025-09-26 15:20:00"
      }
    ],
    "stats": [
      {
        "avg_latency": 0.0234,
        "hostname": "rbz-ai-audit-proxy-prod-8f7a2c9d4b-hx8wp",
        "num_of_requests": 2987,
        "sum_of_bandwidth": 4235890,
        "time_period": 1758818400,
        "timeperiod_string": "2025-09-26 15:00:00"
      },
      {
        "avg_latency": 0.0189,
        "hostname": "rbz-ai-audit-proxy-prod-8f7a2c9d4b-hx8wp",
        "num_of_requests": 3280,
        "sum_of_bandwidth": 4856742,
        "time_period": 1758818700,
        "timeperiod_string": "2025-09-26 15:05:00"
      },
      {
        "avg_latency": 0.0278,
        "hostname": "rbz-ai-audit-proxy-prod-8f7a2c9d4b-hx8wp",
        "num_of_requests": 2845,
        "sum_of_bandwidth": 3967234,
        "time_period": 1758819000,
        "timeperiod_string": "2025-09-26 15:10:00"
      },
      {
        "avg_latency": 0.0156,
        "hostname": "rbz-ai-audit-proxy-prod-8f7a2c9d4b-hx8wp",
        "num_of_requests": 4326,
        "sum_of_bandwidth": 6245678,
        "time_period": 1758819300,
        "timeperiod_string": "2025-09-26 15:15:00"
      },
      {
        "avg_latency": 0.0203,
        "hostname": "rbz-ai-audit-proxy-prod-8f7a2c9d4b-hx8wp",
        "num_of_requests": 3745,
        "sum_of_bandwidth": 5234567,
        "time_period": 1758819600,
        "timeperiod_string": "2025-09-26 15:20:00"
      }
    ],
    "topx": [
      {
        "avg_origin_time": 0.0025740238418159745,
        "avg_waap_time": 0.002293710674090467,
        "avg_total_time": 0.004114890427582266,
        "first_asn": "AS1680",
        "first_geo_country": "Israel",
        "first_organization": "Cellcom Fixed Line Communication L.P",
        "key": "Israel",
        "label": "country",
        "max_origin_time": 0.04,
        "max_waap_time": 0.048833999999999995,
        "max_total_time": 0.054,
        "min_origin_time": 0.001,
        "min_waap_time": 0.0010659999999999999,
        "min_total_time": 0.002,
        "num_of_blocked_requests": 0,
        "num_of_bot_requests": 84054,
        "num_of_challenges": 0,
        "num_of_human_requests": 0,
        "num_of_monitored_requests": 72533,
        "num_of_requests": 84054,
        "sum_of_bytes_sent": 116967517,
        "sum_of_request_length": 69188176
      },
      {
        "avg_origin_time": 0.18171717171717178,
        "avg_waap_time": 0.01128745773032122,
        "avg_total_time": 0.16003229791740214,
        "first_asn": "",
        "first_geo_country": "United States",
        "first_organization": "",
        "key": "United States",
        "label": "country",
        "max_origin_time": 60.001,
        "max_waap_time": 0.38643099999999997,
        "max_total_time": 60.019,
        "min_origin_time": 0.001,
        "min_waap_time": 0.00094,
        "min_total_time": 0,
        "num_of_blocked_requests": 1927,
        "num_of_bot_requests": 11332,
        "num_of_challenges": 0,
        "num_of_human_requests": 0,
        "num_of_monitored_requests": 8858,
        "num_of_requests": 11332,
        "sum_of_bytes_sent": 8614591,
        "sum_of_request_length": 3784066
      },
      {
        "avg_origin_time": 0.1671965532286214,
        "avg_waap_time": 0.011555377158034537,
        "avg_total_time": 0.08474328327714782,
        "first_asn": "",
        "first_geo_country": null,
        "first_organization": null,
        "key": "",
        "label": "country",
        "max_origin_time": 60.007,
        "max_waap_time": 0.098452,
        "max_total_time": 60.012,
        "min_origin_time": 0.001,
        "min_waap_time": 0.00112,
        "min_total_time": 0,
        "num_of_blocked_requests": 5205,
        "num_of_bot_requests": 9789,
        "num_of_challenges": 0,
        "num_of_human_requests": 0,
        "num_of_monitored_requests": 8148,
        "num_of_requests": 9789,
        "sum_of_bytes_sent": 5112983,
        "sum_of_request_length": 3874536
      },
      {
        "avg_origin_time": 0.18792423590185117,
        "avg_waap_time": 0.007640529211087425,
        "avg_total_time": 0.19303113006396588,
        "first_asn": "",
        "first_geo_country": "China",
        "first_organization": "",
        "key": "China",
        "label": "country",
        "max_origin_time": 60.002,
        "max_waap_time": 0.071712,
        "max_total_time": 60.012,
        "min_origin_time": 0.001,
        "min_waap_time": 0.000954,
        "min_total_time": 0.001,
        "num_of_blocked_requests": 22,
        "num_of_bot_requests": 2345,
        "num_of_challenges": 0,
        "num_of_human_requests": 0,
        "num_of_monitored_requests": 1690,
        "num_of_requests": 2345,
        "sum_of_bytes_sent": 2041727,
        "sum_of_request_length": 736628
      },
      {
        "avg_origin_time": 0.1389515648286141,
        "avg_waap_time": 0.007279698542274051,
        "avg_total_time": 0.11336501457725948,
        "first_asn": "",
        "first_geo_country": "Canada",
        "first_organization": "",
        "key": "Canada",
        "label": "country",
        "max_origin_time": 60.001,
        "max_waap_time": 0.10027,
        "max_total_time": 60.012,
        "min_origin_time": 0.001,
        "min_waap_time": 0.000979,
        "min_total_time": 0,
        "num_of_blocked_requests": 373,
        "num_of_bot_requests": 1715,
        "num_of_challenges": 0,
        "num_of_human_requests": 0,
        "num_of_monitored_requests": 1455,
        "num_of_requests": 1715,
        "sum_of_bytes_sent": 1247866,
        "sum_of_request_length": 580128
      }
    ],
    "ai_tools_stats": [
      {
        "tag": "ai-chatgpt",
        "total_requests": 5234,
        "total_passed": 4456,
        "total_blocked": 778,
        "total_blocked_origin": 120,
        "name": "ChatGPT",
        "total_referrals": 3892
      },
      {
        "tag": "ai-claude",
        "total_requests": 4127,
        "total_passed": 3589,
        "total_blocked": 538,
        "total_blocked_origin": 85,
        "name": "Claude",
        "total_referrals": 3124
      },
      {
        "tag": "ai-perplexity",
        "total_requests": 3456,
        "total_passed": 2923,
        "total_blocked": 533,
        "total_blocked_origin": 72,
        "name": "Perplexity",
        "total_referrals": 2567
      },
      {
        "tag": "bing",
        "total_requests": 1521,
        "total_passed": 1214,
        "total_blocked": 307,
        "total_blocked_origin": 45,
        "name": "Bing",
        "total_referrals": 1098
      },
      {
        "tag": "google",
        "total_requests": 2845,
        "total_passed": 2156,
        "total_blocked": 689,
        "total_blocked_origin": 90,
        "name": "Google",
        "total_referrals": 1876
      }
    ]
  },
  "eventsLogData": [
    {
      "time_period": 1727169151,
      "url": "default.site/api/page-32081/cmd.exe",
      "timestamp": "2024-09-24T09:12:31.232177Z",
      "timestamp_min": "2024-09-24T09:12:00Z",
      "blocked": true,
      "monitor": true,
      "challenge": false,
      "ichallenge": false,
      "challenge_type": "",
      "human": false,
      "bot": true,
      "request_id": "36698790377f56a0be2ee73966cc2e42",
      "security_config": {
        "revision": "c745037648c407ced5d0854c441321720b0a74e5",
        "acl_active": true,
        "cf_active": true,
        "gf_rules": 10,
        "rl_rules": 5,
        "cf_rules": 203,
        "secpolid": "__default__",
        "secpolentryid": "__default_entry__"
      },
      "arguments": {
        "a": "test0",
        "b": "test1",
        "c": "test2",
        "d": "test3",
        "e": "test4",
        "f": "test5",
        "g": "test6",
        "h": "test7",
        "i": "test8",
        "j": "test9",
        "k": "test10"
      },
      "is_arguments_null": false,
      "path": "/api/page-32081/cmd.exe",
      "query": "?foo=bar",
      "path_parts": {
        "path": "/api/page-32081/cmd.exe",
        "part3": "cmd.exe",
        "part1": "api",
        "part2": "page-32081"
      },
      "authority": "default.site",
      "cookies": {
        "id": "12"
      },
      "headers": {
        "x-forwarded-port": "80",
        "connection": "Keep-Alive",
        "accept": "*/*",
        "user-agent": "curl/7.74.0",
        "x-forwarded-proto": "http",
        "via": "1.1 google",
        "x-forwarded-for": "105.105.221.153, 35.234.101.233, 34.128.164.93",
        "host": "default.site",
        "x-cloud-trace-context": "777e1d90fd74c416b2cc4df9d32c1101/17499778150234283832",
        "cache-control": "no-cache"
      },
      "tags": {
        "user": ["api"],
        "system": [
          "rtc:trojan-backdoor",
          "all",
          "geo-subregion:16006",
          "securitypolicy-entry:--default--",
          "cf-rule-category:systemresource",
          "cf-rule-subcategory:osci",
          "headers:9",
          "geo-continent-code:af",
          "cf-rule-category:osci",
          "geo-city:algiers",
          "geo-privacy-service:",
          "aclname:acl-default",
          "args:0",
          "bot",
          "cf-rule-name:600135",
          "action:content-filter-block",
          "geo-org:telecom-algeria",
          "ip:105-105-221-153",
          "cf-rule-name:300158",
          "geo-region:algiers",
          "cf-rule-risk:5",
          "cf-rule-subcategory:generic",
          "host:default-site",
          "geo-country:algeria",
          "geo-asn:36947",
          "geo-country-code:dz",
          "network:105-105-192-0-19",
          "scheme:http",
          "securitypolicy:default-security-policy",
          "cookies:0",
          "cf-all",
          "protocol:http-1-1",
          "contentfiltername:default-contentfilter",
          "port:80",
          "geo-continent-name:africa",
          "action:monitor",
          "status:473",
          "status-class:4xx"
        ]
      },
      "ip": "105.105.221.153",
      "method": "GET",
      "bytes_sent": 174,
      "upstream_response_time": null,
      "upstream_status": [],
      "upstream_addr": [],
      "upstream_data": [],
      "request_time": 0.005,
      "request_length": 329,
      "processing_stage": 7,
      "trigger_counters": {
        "gf": 1,
        "dr": 0,
        "rl": 0,
        "cf_restrict": 0,
        "cf": 2,
        "acl": 0,
        "gn": 0
      },
      "acl_triggers": [],
      "rl_triggers": [],
      "gf_triggers": [
        {
          "trigger_id": "waap-api-discovery",
          "trigger_name": "API Discovery",
          "action": "monitor",
          "section": "uri",
          "extra": null,
          "name": null,
          "value": null
        }
      ],
      "dr_triggers": [],
      "cf_triggers": [
        {
          "trigger_id": "__defaultcontentfilter__",
          "trigger_name": "default contentfilter",
          "action": "block",
          "extra": null,
          "section": "uri",
          "name": null,
          "value": null,
          "ruleid": "600135",
          "rule_name": "600135",
          "risk_level": 5
        },
        {
          "trigger_id": "__defaultcontentfilter__",
          "trigger_name": "default contentfilter",
          "action": "block",
          "extra": null,
          "section": "uri",
          "name": null,
          "value": null,
          "ruleid": "300158",
          "rule_name": "300158",
          "risk_level": 5
        }
      ],
      "cf_restrict_triggers": [],
      "gn_triggers": [],
      "reason": "Block - content filter 600135[lvl5] - default contentfilter - [uri]",
      "monitor_reasons": [
        {
          "type": "Global Filter",
          "name": "API Discovery",
          "extra": {}
        }
      ],
      "branch": "prod",
      "profiling": [
        {
          "name": "secpol",
          "value": 40
        },
        {
          "name": "mapping",
          "value": 2773
        },
        {
          "name": "flow",
          "value": 2947
        },
        {
          "name": "limit",
          "value": 4677
        },
        {
          "name": "acl",
          "value": 4684
        },
        {
          "name": "content_filter",
          "value": 6294
        }
      ],
      "version": null,
      "biometric": [],
      "geo_region": "Algiers",
      "host": "default.site",
      "user_agent": "curl/7.74.0",
      "waap_id": "fake-id",
      "port": "80",
      "protocol": "HTTP/1.1",
      "total_time": 0.005,
      "origin_time": 0.001,
      "waap_time": 0.006,
      "referer": "example.com",
      "proxy": "rbzdevzivg01-gcp-euw3-proxy-prod-69b577f797-9fdff",
      "revision": "c745037648c407ced5d0854c441321720b0a74e5",
      "messages": [],
      "session": "70809f479cdb4564312a9b362b5203bfa234de897b72565a31f0c16a",
      "session_ids": [],
      "country": "Argentina",
      "organization": "Telecom Argentina",
      "asn": "AS36947",
      "status": 473,
      "result": "Blocked by WAAP",
      "block_reasons": [
        {
          "type": "Content Filter Rule",
          "name": "600135",
          "extra": {
            "location": "path",
            "name": null,
            "value": null
          }
        },
        {
          "type": "Content Filter Rule",
          "name": "300158",
          "extra": {
            "location": "path",
            "name": null,
            "value": null
          }
        },
        {
          "type": "Content Filter Rule",
          "name": "libinjection-sqli",
          "extra": {
            "location": "path",
            "name": null,
            "value": "g,(e=)",
            "fingerprint": "{\"fingerprint\": \"n,(no)\"}"
          }
        }
      ]
    },
    {
      "time_period": 1727169151,
      "url": "default.site/api/cmd.exe",
      "timestamp": "2024-09-24T09:12:31.191743Z",
      "timestamp_min": "2024-09-24T09:12:00Z",
      "blocked": true,
      "monitor": true,
      "challenge": false,
      "ichallenge": false,
      "challenge_type": "",
      "human": false,
      "bot": true,
      "request_id": "97bad25ba4c544b3dd9e0753d6cf6eab",
      "security_config": {
        "revision": "c745037648c407ced5d0854c441321720b0a74e5",
        "acl_active": true,
        "cf_active": true,
        "gf_rules": 10,
        "rl_rules": 5,
        "cf_rules": 203,
        "secpolid": "__default__",
        "secpolentryid": "__default_entry__"
      },
      "is_arguments_null": false,
      "path": "/api/cmd.exe",
      "query": null,
      "path_parts": {
        "part1": "api",
        "part2": "cmd.exe",
        "path": "/api/cmd.exe"
      },
      "authority": "default.site",
      "cookies": {},
      "headers": {
        "x-forwarded-port": "80",
        "via": "1.1 google",
        "accept": "*/*",
        "x-forwarded-for": "105.221.142.153, 35.234.101.233, 34.128.164.93",
        "user-agent": "curl/7.74.0",
        "x-cloud-trace-context": "3ed108781a83564b6fb199d9ebdb58c9/11875214669834888664",
        "host": "default.site",
        "connection": "Keep-Alive",
        "x-forwarded-proto": "http",
        "cache-control": "no-cache"
      },
      "tags": {
        "user": ["api"],
        "system": [
          "args:0",
          "geo-asn:16637",
          "geo-org:mtn-sa",
          "cf-rule-subcategory:osci",
          "network:105-216-0-0-13",
          "cf-rule-name:600135",
          "ip:105-221-142-153",
          "rtc:trojan-backdoor",
          "host:default-site",
          "geo-country-code:za",
          "cf-all",
          "cf-rule-category:systemresource",
          "cf-rule-subcategory:generic",
          "action:content-filter-block",
          "geo-region:gauteng",
          "all",
          "geo-privacy-service:",
          "bot",
          "geo-city:johannesburg",
          "cf-rule-name:300158",
          "headers:9",
          "protocol:http-1-1",
          "securitypolicy-entry:--default--",
          "scheme:http",
          "aclname:acl-default",
          "contentfiltername:default-contentfilter",
          "port:80",
          "action:monitor",
          "geo-subregion:2030",
          "cookies:0",
          "cf-rule-category:osci",
          "geo-continent-name:africa",
          "geo-continent-code:af",
          "securitypolicy:default-security-policy",
          "geo-country:south-africa",
          "cf-rule-risk:5",
          "status:473",
          "status-class:4xx"
        ]
      },
      "ip": "105.221.142.153",
      "method": "GET",
      "bytes_sent": 174,
      "upstream_response_time": 0.002,
      "upstream_status": [517, 518],
      "upstream_addr": ["35.246.139.148:80"],
      "upstream_data": [
        {
          "response_time": 0.002,
          "status": 517,
          "addr": "35.246.139.148:80"
        },
        {
          "response_time": 0.001,
          "status": 518,
          "addr": "35.246.139.147:80"
        }
      ],
      "request_time": 0.002,
      "request_length": 318,
      "processing_stage": 7,
      "trigger_counters": {
        "gf": 1,
        "dr": 0,
        "rl": 0,
        "cf_restrict": 0,
        "cf": 2,
        "acl": 0,
        "gn": 0
      },
      "acl_triggers": [],
      "rl_triggers": [],
      "gf_triggers": [
        {
          "trigger_id": "waap-api-discovery",
          "trigger_name": "API Discovery",
          "action": "monitor",
          "section": "uri",
          "extra": null,
          "name": null,
          "value": null
        }
      ],
      "dr_triggers": [],
      "cf_triggers": [
        {
          "trigger_id": "__defaultcontentfilter__",
          "trigger_name": "default contentfilter",
          "action": "block",
          "extra": null,
          "section": "uri",
          "name": null,
          "value": null,
          "ruleid": "300158",
          "rule_name": "300158",
          "risk_level": 5
        },
        {
          "trigger_id": "__defaultcontentfilter__",
          "trigger_name": "default contentfilter",
          "action": "block",
          "extra": null,
          "section": "uri",
          "name": null,
          "value": null,
          "ruleid": "600135",
          "rule_name": "600135",
          "risk_level": 5
        }
      ],
      "cf_restrict_triggers": [],
      "gn_triggers": [],
      "reason": "Block - content filter 300158[lvl5] - default contentfilter - [uri]",
      "monitor_reasons": [
        {
          "type": "Global Filter",
          "name": "API Discovery",
          "extra": {}
        }
      ],
      "branch": "prod",
      "profiling": [
        {
          "name": "secpol",
          "value": 25
        },
        {
          "name": "mapping",
          "value": 578
        },
        {
          "name": "flow",
          "value": 667
        },
        {
          "name": "limit",
          "value": 2208
        },
        {
          "name": "acl",
          "value": 2213
        },
        {
          "name": "content_filter",
          "value": 25965
        }
      ],
      "version": null,
      "biometric": [],
      "geo_region": "Gauteng",
      "host": "default.site",
      "user_agent": "curl/7.74.0",
      "waap_id": null,
      "port": "80",
      "protocol": "HTTP/1.1",
      "total_time": 0.002,
      "origin_time": 0.004,
      "waap_time": 0.026,
      "referer": null,
      "proxy": "rbzdevzivg01-gcp-euw3-proxy-prod-69b577f797-9fdff",
      "revision": "c745037648c407ced5d0854c441321720b0a74e5",
      "messages": [],
      "session": "281045ba6e8cd2f3db605bc11b53ad08a317a162ee9a6c7ab6bb95ca",
      "session_ids": [],
      "country": "South Africa",
      "organization": "MTN SA",
      "asn": "AS16637",
      "status": 473,
      "result": "Blocked by WAAP",
      "block_reasons": [
        {
          "type": "Content Filter Rule",
          "name": "300158",
          "extra": {
            "location": "path",
            "name": null,
            "value": null
          }
        },
        {
          "type": "Content Filter Rule",
          "name": "600135",
          "extra": {
            "location": "path",
            "name": null,
            "value": null
          }
        }
      ]
    }
  ],
  "planets": {
    "name": "__default__",
    "trusted_nets": [
      {
        "source": "ip",
        "address": "127.0.0.0/8",
        "comment": "Private subnet"
      },
      {
        "source": "ip",
        "address": "172.16.0.0/12",
        "comment": "Private subnet"
      },
      {
        "source": "ip",
        "address": "10.0.0.0/8",
        "comment": "Private subnet"
      },
      {
        "source": "ip",
        "address": "35.191.0.0/16",
        "comment": "GCP Global external HTTP(S) load balancer"
      },
      {
        "source": "ip",
        "address": "130.211.0.0/22",
        "comment": "GCP Global external HTTP(S) load balancer"
      },
      {
        "source": "ip",
        "address": "34.128.164.93/32",
        "comment": "GCP Prod lb address"
      },
      {
        "source": "ip",
        "address": "35.234.101.233/32",
        "comment": "Demo Generator"
      },
      {
        "source": "global_filter",
        "gf_id": "___9b7f3b18d293",
        "comment": "Demo Generator"
      }
    ],
    "ichallenge": {
      "attrs": {
        "html": {
          "dir": "ltr"
        }
      },
      "palette": ["#4285f4", "#fbbc05", "#34a853", "#f5d57a"],
      "position": {
        "style": "wallpaper"
      },
      "lang": {
        "en": {
          "click": {
            "0": "Click here",
            "1": "Click again"
          },
          "title": "Human verification in process...",
          "src": "some string"
        },
        "ru": {
          "click": {
            "0": "кликните сюда",
            "1": "Нажмите еще раз"
          },
          "title": "Проверка человека в процессе...",
          "src": ""
        }
      }
    },
    "id": "__default__"
  },
  "accounts": {
    "viewer": {
      "acl": "1",
      "mobile": "+972520000000",
      "contact_name": "John Doe viewer",
      "id": "viewer",
      "email": "fake+viewer@link11.com",
      "org_id": "100000000000000000000000",
      "org_name": "Link11 default organization",
      "otpseed": "6VLTHJBFX6BMIMW4"
    },
    "editor": {
      "acl": "11",
      "mobile": "+972520000000",
      "contact_name": "John Doe editor",
      "id": "editor",
      "email": "fake+editor@link11.com",
      "org_id": "100000000000000000000000",
      "org_name": "Link11 default organization",
      "otpseed": "6VLTHJBFX6BMIMW4"
    },
    "orgadmin": {
      "acl": "20",
      "mobile": "+972520000000",
      "contact_name": "John Doe org admin",
      "id": "orgadmin",
      "email": "fake+orgadmin@link11.com",
      "org_id": "100000000000000000000000",
      "org_name": "Link11 default organization",
      "otpseed": "6VLTHJBFX6BMIMW4"
    },
    "rbzadmin": {
      "acl": "100",
      "mobile": "+972520000000",
      "contact_name": "John Doe rbz admin",
      "id": "rbzadmin",
      "email": "fake+rbzadmin@link11.com",
      "org_id": "100000000000000000000000",
      "org_name": "Link11 default organization",
      "otpseed": "6VLTHJBFX6BMIMW4"
    },
    "missingotp": {
      "acl": "100",
      "mobile": "+972520000000",
      "contact_name": "John Doe missing otp",
      "id": "missingotp",
      "email": "fake+missingotp@link11.com",
      "org_id": "100000000000000000000000",
      "org_name": "Link11 default organization"
    }
  },
  "accountApiKeys": {
    "items": [
      {
        "email": "fake@link11.com",
        "account_id": "viewer",
        "key": "3a-tiFQyFgAXKO16Dya_PXY",
        "id": "4ae2-befd",
        "created_by": "viewer",
        "created_time": 1707294062.783418,
        "title": "test"
      },
      {
        "email": "fake@link11.com",
        "account_id": "viewer",
        "key": "3a-tiFQyFgAXKO16Dya_P",
        "id": "4ae2-befd",
        "created_by": "viewer",
        "created_time": 1707294062.783418,
        "title": "OnboardingTester"
      },
      {
        "email": "fake@link11.com",
        "account_id": "viewer",
        "key": "3a-tiFQyFgAXKO16Dya_PYZ",
        "id": "4ae2-befd",
        "created_by": "viewer",
        "created_time": 1707294062.783418,
        "title": "test 2"
      }
    ]
  },
  "aclProfiles": {
    "items": [
      {
        "id": "__acldefault__",
        "name": "default-acl",
        "description": "New ACL Profile description and remarks.",
        "action": "action-acl-block",
        "tags": ["test", "tag"],
        "allow": [],
        "allow_bot": ["google"],
        "deny_bot": ["yahoo"],
        "passthrough": ["internal", "devops"],
        "deny": ["tor"],
        "force_deny": ["china", "ukraine"]
      },
      {
        "id": "d16fd217e6b9",
        "name": "ACL Profile referenced by Security Policy",
        "description": "ACL Profile referenced by Security Policy",
        "allow": [],
        "allow_bot": [],
        "deny_bot": [],
        "passthrough": [],
        "deny": [],
        "force_deny": [],
        "tags": [],
        "action": "action-acl-block"
      },
      {
        "id": "417d5fdc6029",
        "name": "Action ACL Profile",
        "description": "New ACL Profile description and remarks.",
        "allow": [],
        "allow_bot": [],
        "deny_bot": [],
        "passthrough": [],
        "deny": [],
        "force_deny": [],
        "tags": [],
        "action": "action-acl-block"
      },
      {
        "id": "2d2ece0e5757",
        "name": "Delete ACL Profile",
        "description": "New ACL Profile description and remarks.",
        "allow": [],
        "allow_bot": [],
        "deny_bot": [],
        "passthrough": [],
        "deny": [],
        "force_deny": [],
        "tags": [],
        "action": "action-acl-block"
      },
      {
        "id": "edit",
        "name": "Edit ACL Profile",
        "description": "New ACL Profile description and remarks.",
        "allow": ["allow-list"],
        "allow_bot": ["allow-bot-list"],
        "deny_bot": ["deny-bot-list"],
        "passthrough": ["passthrough-list"],
        "deny": ["deny-list"],
        "force_deny": ["force-deny-list"],
        "tags": ["custom-tag"],
        "action": "action-acl-block"
      }
    ]
  },
  "actions": {
    "items": [
      {
        "id": "action-monitor",
        "name": "default monitoring action",
        "description": "New Action description and remarks.",
        "tags": [],
        "type": "monitor"
      },
      {
        "id": "action-waap-feed-block",
        "name": "WAAP feed block",
        "description": "New Action description and remarks.",
        "tags": [],
        "type": "block"
      },
      {
        "id": "action-https-redirect",
        "name": "https redirect",
        "description": "New Action description and remarks.",
        "tags": [],
        "type": "block"
      },
      {
        "id": "action-acl-block",
        "name": "acl profile block",
        "description": "New Action description and remarks.",
        "tags": [],
        "type": "block",
        "params": {
          "status": 472,
          "content": "access denied",
          "headers": {
            "content-type": "text/html"
          }
        }
      },
      {
        "id": "contentfilter-block",
        "name": "content filter profile block",
        "description": "New Action description and remarks.",
        "tags": [],
        "type": "block",
        "params": {
          "status": 473,
          "content": "access denied",
          "headers": {
            "content-type": "text/html"
          }
        }
      },
      {
        "id": "dynamic-rule-block",
        "name": "dynamic rule block",
        "description": "New Action description and remarks.",
        "tags": [],
        "type": "block",
        "params": {
          "status": 474,
          "content": "access denied",
          "headers": {
            "content-type": "text/html"
          }
        }
      },
      {
        "id": "global-filter-block",
        "name": "global filter block",
        "description": "New Action description and remarks.",
        "tags": [],
        "type": "block",
        "params": {
          "status": 470,
          "content": "access denied",
          "headers": {
            "content-type": "text/html"
          }
        }
      },
      {
        "id": "rate-limit-block",
        "name": "rate limit rule block",
        "description": "New Action description and remarks.",
        "tags": [],
        "type": "block",
        "params": {
          "status": 471,
          "content": "access denied",
          "headers": {
            "content-type": "text/html"
          }
        }
      },
      {
        "id": "341bb5ce241c",
        "name": "Delete Action",
        "description": "New Action description and remarks.",
        "tags": [],
        "type": "monitor"
      },
      {
        "id": "edit",
        "name": "Edit Action",
        "description": "New Action description and remarks.",
        "tags": ["test-tag"],
        "type": "monitor"
      },
      {
        "id": "edit-block-1",
        "name": "Edit Action",
        "description": "New Action description and remarks.",
        "tags": ["test2", "test22", "test222"],
        "type": "block",
        "params": {
          "status": "404",
          "headers": {
            "foo": "bar",
            "aaa": "bbb"
          },
          "content": "test content"
        }
      },
      {
        "id": "edit-block-2",
        "name": "Edit Action",
        "description": "New Action description and remarks.",
        "tags": [],
        "type": "block",
        "params": {
          "status": "503",
          "headers": {},
          "content": "test content"
        }
      },
      {
        "id": "edit-block-3",
        "name": "Edit Action",
        "description": "New Action description and remarks.",
        "tags": [],
        "type": "block"
      },
      {
        "id": "edit-monitor-1",
        "name": "Edit Action",
        "description": "New Action description and remarks.",
        "tags": ["test-tag"],
        "type": "monitor",
        "params": {
          "headers": {
            "foo": "bar",
            "aaa": "bbb"
          }
        }
      },
      {
        "id": "edit-monitor-2",
        "name": "Edit Action",
        "description": "New Action description and remarks.",
        "tags": ["test-tag"],
        "type": "monitor",
        "params": {
          "headers": {}
        }
      },
      {
        "id": "edit-monitor-3",
        "name": "Edit Action",
        "description": "New Action description and remarks.",
        "tags": ["test-tag"],
        "type": "monitor"
      },
      {
        "id": "edit-skip-1",
        "name": "Edit Action",
        "description": "New Action description and remarks.",
        "tags": ["test-tag"],
        "type": "skip"
      },
      {
        "id": "edit-challenge-1",
        "name": "Edit Action",
        "description": "New Action description and remarks.",
        "tags": ["test-tag"],
        "type": "challenge"
      },
      {
        "id": "edit-ichallenge-1",
        "name": "Edit Action",
        "description": "New Action description and remarks.",
        "tags": ["test-tag"],
        "type": "ichallenge"
      }
    ]
  },
  "backendServices": {
    "items": [
      {
        "back_hosts": [
          {
            "backup": false,
            "down": false,
            "fail_timeout": 10,
            "host": "example.com",
            "http_port": [80],
            "https_port": [443],
            "max_fails": 0,
            "monitor_state": "0",
            "weight": 1
          }
        ],
        "http11": true,
        "id": "__default__",
        "least_conn": false,
        "name": "example-com",
        "description": "",
        "sticky": "none",
        "sticky_cookie_name": "",
        "transport_mode": "default",
        "mtls_certificate": "3140fe92",
        "mtls_trusted_certificate": "b34e77ad777c"
      },
      {
        "back_hosts": [
          {
            "backup": false,
            "down": false,
            "fail_timeout": 10,
            "host": "127.0.0.1",
            "http_port": [80],
            "https_port": [443],
            "max_fails": 0,
            "monitor_state": "",
            "weight": 1
          }
        ],
        "http11": true,
        "id": "6f6295de664f",
        "least_conn": false,
        "name": "Backend Service referenced by Security Policy",
        "description": "New Backend Service description and remarks.",
        "sticky": "none",
        "transport_mode": "default",
        "mtls_certificate": "3140fe92",
        "mtls_trusted_certificate": "b34e77ad777c"
      },
      {
        "back_hosts": [
          {
            "backup": false,
            "down": false,
            "fail_timeout": 10,
            "host": "test.example.com",
            "http_port": [80],
            "https_port": [443],
            "max_fails": 0,
            "monitor_state": "0",
            "weight": 1
          }
        ],
        "http11": true,
        "id": "c84a01fbe369",
        "least_conn": false,
        "name": "Delete Backend Service",
        "description": "",
        "sticky": "none",
        "sticky_cookie_name": "",
        "transport_mode": "default",
        "mtls_certificate": "",
        "mtls_trusted_certificate": ""
      },
      {
        "back_hosts": [
          {
            "backup": false,
            "down": false,
            "fail_timeout": 10,
            "host": "edit.example",
            "http_port": [80],
            "https_port": [443],
            "max_fails": 0,
            "monitor_state": "0",
            "weight": 1
          }
        ],
        "http11": true,
        "id": "edit",
        "least_conn": false,
        "name": "edit-example",
        "description": "",
        "sticky": "none",
        "sticky_cookie_name": "",
        "transport_mode": "default",
        "mtls_certificate": "",
        "mtls_trusted_certificate": ""
      }
    ]
  },
  "contentFilterProfiles": {
    "items": [
      {
        "id": "__defaultcontentfilter__",
        "name": "default contentfilter",
        "description": "",
        "ignore_alphanum": true,
        "args": {
          "max_count": 512,
          "max_length": 1024,
          "enable_max_length": true,
          "enable_max_count": true,
          "names": [],
          "regex": [],
          "text": []
        },
        "headers": {
          "max_count": 42,
          "max_length": 1024,
          "enable_max_length": true,
          "enable_max_count": true,
          "names": [],
          "regex": [],
          "text": []
        },
        "cookies": {
          "max_count": 42,
          "max_length": 1024,
          "enable_max_length": true,
          "enable_max_count": true,
          "names": [],
          "regex": [],
          "text": []
        },
        "url": {
          "max_count": 42,
          "max_length": 1024,
          "enable_max_length": true,
          "enable_max_count": true,
          "names": [],
          "regex": [],
          "text": []
        },
        "path": {
          "max_count": 42,
          "max_length": 1024,
          "enable_max_length": true,
          "enable_max_count": true,
          "names": [],
          "regex": [],
          "text": []
        },
        "allsections": {
          "max_count": 42,
          "max_length": 1024,
          "enable_max_length": true,
          "enable_max_count": true,
          "names": [],
          "regex": [],
          "text": []
        },
        "decoding": {
          "base64": true,
          "dual": true,
          "html": false,
          "unicode": false
        },
        "masking_seed": "CHANGEME",
        "content_type": [],
        "active": [
          "cf-rule-risk:5",
          "cf-rule-risk:4",
          "cf-rule-risk:3",
          "cf-rule-subcategory:libinjection-xss"
        ],
        "report": [
          "cf-rule-name:200003",
          "cf-rule-name:200160",
          "cf-rule-name:200161",
          "cf-rule-name:200162",
          "cf-rule-name:300008",
          "cf-rule-name:300009",
          "cf-rule-name:300010",
          "cf-rule-name:500001",
          "cf-rule-name:500002",
          "cf-rule-name:500110",
          "cf-rule-name:500111",
          "cf-rule-name:500112",
          "cf-rule-name:700010",
          "cf-rule-name:700011",
          "cf-rule-name:700012",
          "cf-rule-name:800013",
          "cf-rule-name:900004",
          "cf-rule-name:910000",
          "cf-rule-name:910001",
          "cf-rule-name:920005",
          "cf-rule-name:920006",
          "cf-rule-name:920007",
          "cf-rule-name:920008",
          "cf-rule-name:920009",
          "cf-rule-name:920010",
          "cf-rule-name:920011",
          "cf-rule-name:920012",
          "cf-rule-name:920013",
          "cf-rule-name:920014",
          "cf-rule-name:920015",
          "cf-rule-name:920016",
          "cf-rule-name:920017"
        ],
        "ignore": ["test-tag"],
        "tags": [],
        "action": "action-contentfilter-block"
      },
      {
        "id": "f4dbffdf8ecc",
        "name": "Content Filter Profile referenced by Security Policy",
        "description": "",
        "ignore_alphanum": true,
        "args": {
          "max_count": 512,
          "max_length": 1024,
          "enable_max_length": true,
          "enable_max_count": true,
          "names": [],
          "regex": []
        },
        "headers": {
          "max_count": 42,
          "max_length": 1024,
          "enable_max_length": true,
          "enable_max_count": true,
          "names": [],
          "regex": []
        },
        "cookies": {
          "max_count": 42,
          "max_length": 1024,
          "enable_max_length": true,
          "enable_max_count": true,
          "names": [],
          "regex": []
        },
        "path": {
          "max_count": 42,
          "max_length": 1024,
          "enable_max_length": true,
          "enable_max_count": true,
          "names": [],
          "regex": []
        },
        "allsections": {
          "max_count": 42,
          "max_length": 1024,
          "enable_max_length": true,
          "enable_max_count": true,
          "names": [],
          "regex": []
        },
        "decoding": {
          "base64": true,
          "dual": true,
          "html": false,
          "unicode": false
        },
        "masking_seed": "CHANGEME",
        "content_type": [],
        "active": [
          "cf-rule-risk:5",
          "cf-rule-risk:4",
          "cf-rule-risk:3",
          "cf-rule-subcategory:libinjection-xss"
        ],
        "report": [],
        "ignore": ["test-tag"],
        "tags": [],
        "action": "action-contentfilter-block"
      },
      {
        "id": "c18637de965b",
        "name": "Action Content Filter Profile",
        "description": "New Content Filter Profile description and remarks.",
        "ignore_alphanum": true,
        "args": {
          "names": [],
          "regex": [],
          "max_count": 512,
          "enable_max_count": false,
          "max_length": 1024,
          "enable_max_length": false
        },
        "headers": {
          "max_count": 42,
          "max_length": 1024,
          "enable_max_length": false,
          "enable_max_count": false,
          "names": [
            {
              "type": "names",
              "key": "test key",
              "reg": "test",
              "restrict": true,
              "mask": true,
              "ignore_cf_rule_tags": ["yahoo-crawler"],
              "ignore": ["yahoo-crawler"],
              "id": "a3ed5c1bec79"
            }
          ],
          "regex": [
            {
              "type": "regex",
              "key": "testregex",
              "reg": "test",
              "restrict": false,
              "mask": true,
              "ignore_cf_rule_tags": ["pingdom-probe"],
              "id": "7354b98c826b",
              "ignore": ["pingdom-probe"]
            }
          ]
        },
        "cookies": {
          "names": [],
          "regex": [],
          "max_count": 42,
          "enable_max_count": false,
          "max_length": 1024,
          "enable_max_length": false
        },
        "path": {
          "names": [],
          "regex": [],
          "max_count": 42,
          "enable_max_count": false,
          "max_length": 1024,
          "enable_max_length": false
        },
        "allsections": {
          "names": [],
          "regex": [],
          "max_count": 42,
          "enable_max_count": false,
          "max_length": 1024,
          "enable_max_length": false
        },
        "decoding": {
          "base64": true,
          "dual": true,
          "html": false,
          "unicode": false
        },
        "masking_seed": "CHANGEME",
        "graphql_path": "",
        "content_type": ["json", "multipart_form"],
        "active": [],
        "report": [],
        "ignore": [],
        "tags": [],
        "action": "contentfilter-block",
        "ignore_body": false
      },
      {
        "id": "c90c19002051",
        "name": "Delete Content Filter Profile",
        "description": "New Content Filter Profile description and remarks.",
        "ignore_alphanum": true,
        "args": {
          "names": [],
          "regex": [],
          "max_count": 512,
          "enable_max_count": false,
          "max_length": 1024,
          "enable_max_length": false
        },
        "headers": {
          "names": [],
          "regex": [],
          "max_count": 42,
          "enable_max_count": false,
          "max_length": 1024,
          "enable_max_length": false
        },
        "cookies": {
          "names": [],
          "regex": [],
          "max_count": 42,
          "enable_max_count": false,
          "max_length": 1024,
          "enable_max_length": false
        },
        "path": {
          "names": [],
          "regex": [],
          "max_count": 42,
          "enable_max_count": false,
          "max_length": 1024,
          "enable_max_length": false
        },
        "allsections": {
          "names": [],
          "regex": [],
          "max_count": 42,
          "enable_max_count": false,
          "max_length": 1024,
          "enable_max_length": false
        },
        "decoding": {
          "base64": true,
          "dual": true,
          "html": false,
          "unicode": false
        },
        "masking_seed": "CHANGEME",
        "graphql_path": "",
        "content_type": [],
        "active": [],
        "report": [],
        "ignore": [],
        "tags": [],
        "action": "action-contentfilter-block",
        "ignore_body": false
      }
    ],
    "contentFilterRuleTags": [
      "cf-rule-name:200003",
      "cf-rule-name:200160",
      "cf-rule-name:200161",
      "cf-rule-name:200162",
      "cf-rule-name:300008",
      "cf-rule-name:300009",
      "cf-rule-name:300010",
      "cf-rule-name:500001",
      "cf-rule-name:500002",
      "cf-rule-name:500110",
      "cf-rule-name:500111",
      "cf-rule-name:500112",
      "cf-rule-name:700010",
      "cf-rule-name:700011",
      "cf-rule-name:700012",
      "cf-rule-name:800013",
      "cf-rule-name:900004",
      "cf-rule-name:910000",
      "cf-rule-name:910001",
      "cf-rule-name:920005",
      "cf-rule-name:920006",
      "cf-rule-name:920007",
      "cf-rule-name:920008",
      "cf-rule-name:920009",
      "cf-rule-name:920010",
      "cf-rule-name:920011",
      "cf-rule-name:920012",
      "cf-rule-name:920013",
      "cf-rule-name:920014",
      "cf-rule-name:920015",
      "cf-rule-name:920016",
      "cf-rule-name:920017",
      "cf-rule-risk:5",
      "cf-rule-risk:4",
      "cf-rule-risk:3",
      "cf-rule-subcategory:libinjection-xss"
    ]
  },
  "contentFilterRules": {
    "items": [
      {
        "id": "100000",
        "name": "Content Filter Rule Example",
        "description": "",
        "msg": "SQLi Attempt (Conditional Operator Detected)",
        "operand": "\\s(and|or)\\s+\\d+\\s+.*between\\s.*\\d+\\s+and\\s+\\d+.*",
        "category": "sqli",
        "subcategory": "statement injection",
        "risk": 5,
        "tags": ["rtc:injection"]
      },
      {
        "id": "edit",
        "name": "Content Filter Rule Example",
        "description": "",
        "msg": "SQLi Attempt (Conditional Operator Detected)",
        "operand": "\\s(and|or)\\s+\\d+\\s+.*between\\s.*\\d+\\s+and\\s+\\d+.*",
        "category": "sqli",
        "subcategory": "statement injection",
        "risk": 5,
        "tags": ["rtc:injection"]
      }
    ]
  },
  "dnsRecords": {
    "zone_id": "Z099081731FYJAQ9FW92B",
    "dns_records": [
      {
        "name": "fire-prod-gcp-euw3-yapx.rbzdevfakenpru.dev.rbzdns.com.",
        "resource_records": ["127.0.0.1"],
        "ttl": 300,
        "type": "A"
      },
      {
        "name": "no resource records",
        "ttl": 900,
        "type": "SOA"
      },
      {
        "name": "empty resource records",
        "resource_records": [],
        "ttl": 900,
        "type": "SOA"
      }
    ]
  },
  "dynamicRules": {
    "items": [
      {
        "id": "5ec50da4f5ef",
        "name": "New Dynamic Rule",
        "description": "New Dynamic Rule description and remarks.",
        "threshold": 9999,
        "timeframe": 60,
        "ttl": 7200,
        "active": false,
        "action": "action-dynamic-rule-block",
        "target": "ip",
        "offload_ip_filtering": true,
        "include": {
          "relation": "OR",
          "tags": ["all"]
        },
        "exclude": {
          "relation": "OR",
          "tags": []
        }
      },
      {
        "id": "b40b596e6710",
        "name": "Action Dynamic Rule",
        "description": "New Dynamic Rule description and remarks.",
        "threshold": 9999,
        "timeframe": 60,
        "ttl": 7200,
        "active": false,
        "action": "dynamic-rule-block",
        "target": "ip",
        "offload_ip_filtering": false,
        "include": {
          "relation": "OR",
          "tags": ["all"]
        },
        "exclude": {
          "relation": "OR",
          "tags": []
        }
      },
      {
        "id": "bf80d0dfdc2a",
        "name": "Delete Dynamic Rule",
        "description": "New Dynamic Rule description and remarks.",
        "threshold": 9999,
        "timeframe": 60,
        "ttl": 7200,
        "active": false,
        "action": "action-dynamic-rule-block",
        "target": "ip",
        "offload_ip_filtering": false,
        "include": {
          "relation": "OR",
          "tags": ["all"]
        },
        "exclude": {
          "relation": "OR",
          "tags": []
        },
        "tags": ["api", "okay"]
      },
      {
        "id": "edit",
        "active": true,
        "include": {
          "relation": "OR",
          "tags": ["all"]
        },
        "exclude": {
          "relation": "OR",
          "tags": []
        },
        "name": "test dynamic rule",
        "description": "New Dynamic Rule description and remarks 2",
        "tags": ["api", "okay"],
        "action": "action-dynamic-rule-block",
        "target": "cookie_foo",
        "offload_ip_filtering": false,
        "threshold": 2,
        "timeframe": 3,
        "ttl": 72000
      },
      {
        "id": "ca644e0cda95",
        "name": "Quarantined Dynamic Rule",
        "description": "Quarantined",
        "threshold": 1,
        "timeframe": 60,
        "ttl": 7200,
        "active": false,
        "action": "action-dynamic-rule-block",
        "target": "ip",
        "offload_ip_filtering": true,
        "include": {
          "relation": "OR",
          "tags": ["all"]
        },
        "exclude": {
          "relation": "OR",
          "tags": []
        }
      },
      {
        "id": "max-ttl-rule-10years",
        "name": "Max TTL Dynamic Rule (10 years)",
        "description": "Rule with maximum TTL of 87,658 hours (~10 years)",
        "threshold": 5,
        "timeframe": 3600,
        "ttl": 315568800,
        "active": true,
        "action": "action-monitor",
        "target": "ip",
        "offload_ip_filtering": false,
        "include": {
          "relation": "OR",
          "tags": ["all"]
        },
        "exclude": {
          "relation": "OR",
          "tags": []
        }
      }
    ]
  },
  "edgeFunctions": {
    "items": [
      {
        "id": "__default__",
        "name": "Default Edge Function",
        "description": "2 requests per minute",
        "phase": "response_pre",
        "code": "-- begin custom code\n--action header\nngx.header['foo'] = 'bar'"
      },
      {
        "id": "f971e92459e2",
        "name": "Edge Function referenced by Security Policy",
        "description": "5 requests per minute",
        "phase": "request_pre",
        "code": "-- begin custom code\n--action header\nngx.header['foo'] = 'bar'"
      },
      {
        "id": "f123456789",
        "name": "Delete Edge Function",
        "description": "2 requests per minute",
        "phase": "response_pre",
        "code": "-- begin custom code\n--action header,\nngx.header['foo'] = 'bar'"
      },
      {
        "id": "edit",
        "name": "New Edge Functions",
        "description": "5 requests per minute",
        "phase": "request_pre",
        "code": "-- begin custom code\n--action header,\nngx.header['foo'] = 'bar'"
      }
    ]
  },
  "flowControlPolicies": {
    "items": [
      {
        "id": "__flow_sample__",
        "name": "Flow Control Policy Example",
        "description": "GET to /login page *before* POSTing credentials",
        "timeframe": 60,
        "key": [
          {
            "attrs": "ip"
          }
        ],
        "steps": [
          {
            "args": {},
            "cookies": {},
            "headers": {
              "host": "www.example.com"
            },
            "method": "GET",
            "uri": "/login"
          },
          {
            "args": {},
            "cookies": {},
            "headers": {
              "host": "www.example.com"
            },
            "method": "POST",
            "uri": "/login"
          }
        ],
        "tags": ["rtc:ato", "legit-flow-ui-login"],
        "include": ["all"],
        "exclude": ["internal:devops-ci-cd"],
        "active": false
      },
      {
        "id": "dd560cd709ed",
        "name": "Flow Control Policy with empty steps",
        "description": "empty steps",
        "timeframe": 60,
        "key": [
          {
            "attrs": "ip"
          }
        ],
        "steps": [],
        "tags": [],
        "include": ["all"],
        "exclude": [],
        "active": true
      },
      {
        "id": "7e9096ce831f",
        "name": "Flow Control Policy without steps",
        "description": "no steps",
        "timeframe": 60,
        "key": [
          {
            "attrs": "ip"
          }
        ],
        "tags": [],
        "include": ["all"],
        "exclude": [],
        "active": true
      },
      {
        "id": "edit",
        "name": "Edit Flow Control Policy",
        "description": "GET to /login page *before* POSTing credentials",
        "timeframe": 60,
        "key": [
          {
            "attrs": "ip"
          }
        ],
        "steps": [
          {
            "args": {},
            "cookies": {},
            "headers": {
              "host": "www.example.com"
            },
            "method": "GET",
            "uri": "/login"
          },
          {
            "args": {},
            "cookies": {},
            "headers": {
              "host": "www.example.com"
            },
            "method": "POST",
            "uri": "/login"
          }
        ],
        "tags": ["rtc:ato", "legit-flow-ui-login"],
        "include": ["all"],
        "exclude": ["internal:devops-ci-cd"],
        "active": false
      },
      {
        "id": "65255f403832",
        "name": "Delete Flow Control Policy",
        "description": "Delete",
        "timeframe": 60,
        "key": [
          {
            "attrs": "ip"
          }
        ],
        "steps": [
          {
            "args": {},
            "cookies": {},
            "headers": {
              "host": "www.example.com"
            },
            "method": "GET",
            "uri": "/login"
          },
          {
            "args": {},
            "cookies": {},
            "headers": {
              "host": "www.example.com"
            },
            "method": "POST",
            "uri": "/login"
          }
        ],
        "tags": [],
        "include": ["all"],
        "exclude": [],
        "active": true
      }
    ]
  },
  "globalFilters": {
    "items": [
      {
        "id": "waap-api-discovery",
        "name": "API Discovery",
        "source": "self-managed",
        "mdate": "2020-05-23T00:04:41",
        "description": "Tag API Requests",
        "active": true,
        "tags": ["api", "okay"],
        "action": "action-global-filter-block",
        "rule": {
          "relation": "OR",
          "entries": [
            {
              "relation": "OR",
              "entries": [["ip", "1.1.1.1", null]]
            },
            {
              "relation": "OR",
              "entries": [["ip", "2.2.2.2", null]]
            },
            {
              "relation": "OR",
              "entries": [["headers", ["headerrr", "valueeee"], "anooo"]]
            }
          ]
        }
      },
      {
        "id": "example_id",
        "name": "Crawler example",
        "active": true,
        "mdate": "2020-11-04 07:54:27.417791",
        "source": "https://example.com",
        "description": "some example crawlers",
        "tags": ["allowlist", "crawler"],
        "rule": {
          "relation": "OR",
          "entries": [
            {
              "relation": "OR",
              "entries": [["ip", "1.1.1.1", null]]
            },
            {
              "relation": "OR",
              "entries": [["ip", "2.2.2.2", null]]
            },
            {
              "relation": "OR",
              "entries": [["headers", ["headerrr", "valueeee"], "anooo"]]
            }
          ]
        }
      },
      {
        "id": "__65255f403832",
        "name": "Action Global Filter",
        "source": "https://test.com",
        "mdate": "",
        "description": "New Global Filter description and remarks.",
        "active": false,
        "action": "global-filter-block",
        "tags": [],
        "rule": {
          "relation": "OR",
          "entries": []
        }
      },
      {
        "id": "9b7f3b18d293",
        "name": "Delete Global Filter",
        "source": "self-managed",
        "mdate": "",
        "description": "New Global Filter description and remarks.",
        "active": false,
        "action": "action-monitor",
        "tags": [],
        "rule": {
          "relation": "OR",
          "entries": []
        }
      },
      {
        "id": "___9b7f3b18d293",
        "name": "Global Filter in Trusted Source",
        "source": "self-managed",
        "mdate": "",
        "description": "New Global Filter description and remarks.",
        "active": false,
        "action": "action-monitor",
        "tags": [],
        "rule": {
          "relation": "OR",
          "entries": []
        }
      },
      {
        "id": "test-gfentry-flat",
        "name": "Flat GFEntry Rule",
        "source": "self-managed",
        "mdate": "2026-04-10T12:00:00Z",
        "description": "Global filter with flat GFEntry array rule format",
        "active": false,
        "action": "action-global-filter-block",
        "tags": ["test"],
        "rule": ["path", "/test", "annotation"]
      }
    ]
  },
  "logExporters": {
    "items": [
      {
        "id": "default",
        "name": "Test Log Exporter 1",
        "active": true,
        "filter": "all",
        "format": "custom_syslog",
        "include_request_data": true,
        "server_groups": {
          "all": true,
          "ids": []
        },
        "connection": {
          "host": "10.10.10.15",
          "port": 6514,
          "protocol": "tcp",
          "tls_mode": "tls",
          "certificate": {
            "cert_body": "-----BEGIN CERTIFICATE-----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\nM93R0mXlS4uWTDcFOz95VNgM3wZd3QqNy8j7i5ihKOsIcs4=\n-----END CERTIFICATE-----",
            "chain_data": [
              {
                "cn": "C=XX, ST=StateName, L=CityName, O=CompanyName, OU=CompanySectionName, CN=CommonNameOrHostname",
                "exp_date": "2034-10-08"
              }
            ]
          }
        }
      },
      {
        "id": "c844a8fdd22b",
        "name": "Test Log Exporter 2",
        "active": false,
        "filter": "blocked",
        "format": "custom_syslog",
        "include_request_data": false,
        "server_groups": {
          "all": false,
          "ids": ["__default__"]
        },
        "connection": {
          "host": "10.10.10.1",
          "port": 514,
          "protocol": "tcp",
          "tls_mode": "no_tls"
        }
      }
    ]
  },
  "mobileApplicationGroups": {
    "items": [
      {
        "id": "a1b3c2d3d912",
        "name": "Mobile Application Group Test",
        "description": "New Mobile SDK Description and Remarks",
        "grace": "50",
        "uid_header": "authorization",
        "signatures": [],
        "active_config": [
          {
            "active": true,
            "json": "{}",
            "name": "Default"
          }
        ]
      },
      {
        "id": "d8bb3d912af6",
        "name": "Mobile Application Group referenced by Server Group",
        "description": "New Mobile SDK Description and Remarks 1",
        "grace": "50",
        "uid_header": "authorization",
        "signatures": [],
        "active_config": [
          {
            "active": true,
            "json": "{}",
            "name": "Default"
          }
        ]
      },
      {
        "id": "b0f34541fa01",
        "name": "Delete Mobile Application Group",
        "description": "Mobile Application Group Description and Remarks",
        "grace": "5",
        "uid_header": "authorization",
        "signatures": [],
        "active_config": [
          {
            "active": true,
            "json": "{}",
            "name": "Default"
          }
        ]
      },
      {
        "id": "edit",
        "name": "New Mobile Application Group 111",
        "description": "Mobile Application Group Description and Remarks 111",
        "grace": "5",
        "uid_header": "authorization",
        "signatures": [
          {
            "active": true,
            "hash": "abcdef1234567890",
            "name": "Default"
          }
        ],
        "active_config": [
          {
            "active": true,
            "json": "{}",
            "name": "Default"
          }
        ]
      }
    ]
  },
  "proxyTemplates": {
    "items": [
      {
        "acao_header": false,
        "client_body_timeout": "30",
        "client_header_timeout": "10",
        "client_max_body_size": "150",
        "client_header_buffer_size": "1",
        "large_client_header_buffers_size": "32",
        "large_client_header_buffers_count": "2",
        "client_body_buffer_size": "4",
        "advanced_configuration": [],
        "custom_listener": false,
        "description": "",
        "id": "__default__",
        "keepalive_timeout": "60",
        "limit_req_burst": "40",
        "limit_req_rate": "500",
        "mask_headers": "server*|Server*|Powered-*|powered-*",
        "name": "Default Proxy Template",
        "post_private_args": "(cc_number|password)",
        "proxy_connect_timeout": "15",
        "proxy_read_timeout": "60",
        "proxy_send_timeout": "30",
        "send_timeout": "10",
        "session_key": "cookie_jsessionid",
        "upstream_host": "$host",
        "xff_header_name": ["X-Forwarded-For", "X-Real-IP"],
        "xrealip_header_name": "X-Real-IP"
      },
      {
        "acao_header": false,
        "client_body_timeout": "5",
        "client_header_timeout": "5",
        "client_max_body_size": "150",
        "client_header_buffer_size": "1",
        "large_client_header_buffers_size": "32",
        "large_client_header_buffers_count": "2",
        "client_body_buffer_size": "4",
        "advanced_configuration": [],
        "custom_listener": false,
        "description": "New Proxy Template description and remarks.",
        "id": "3aed9031176d",
        "keepalive_timeout": "660",
        "limit_req_burst": "400",
        "limit_req_rate": "1200",
        "mask_headers": "",
        "name": "Proxy Template referenced by Server Group",
        "proxy_connect_timeout": "5",
        "proxy_read_timeout": "60",
        "proxy_send_timeout": "30",
        "send_timeout": "5",
        "upstream_host": "$host",
        "xff_header_name": ["X-Forwarded-For"],
        "xrealip_header_name": "X-Real-IP"
      },
      {
        "acao_header": false,
        "client_body_timeout": "5",
        "client_header_timeout": "5",
        "client_max_body_size": "150",
        "client_header_buffer_size": "1",
        "large_client_header_buffers_size": "32",
        "large_client_header_buffers_count": "2",
        "client_body_buffer_size": "4",
        "advanced_configuration": [],
        "custom_listener": false,
        "description": "New Proxy Template description and remarks.",
        "id": "00b2acde6d94",
        "keepalive_timeout": "660",
        "limit_req_burst": "400",
        "limit_req_rate": "1200",
        "mask_headers": "",
        "name": "Delete Proxy Template",
        "proxy_connect_timeout": "5",
        "proxy_read_timeout": "60",
        "proxy_send_timeout": "30",
        "send_timeout": "5",
        "upstream_host": "$host",
        "xff_header_name": ["X-Forwarded-For"],
        "xrealip_header_name": "X-Real-IP"
      },
      {
        "acao_header": false,
        "client_body_timeout": "5",
        "client_header_timeout": "5",
        "client_max_body_size": "150",
        "client_header_buffer_size": "1",
        "large_client_header_buffers_size": "32",
        "large_client_header_buffers_count": "2",
        "client_body_buffer_size": "4",
        "advanced_configuration": [],
        "custom_listener": false,
        "description": "New Proxy Template description and remarks 111",
        "id": "edit",
        "keepalive_timeout": "660",
        "limit_req_burst": "400",
        "limit_req_rate": "1200",
        "mask_headers": "",
        "name": "New Proxy Template 111",
        "proxy_connect_timeout": "5",
        "proxy_read_timeout": "60",
        "proxy_send_timeout": "30",
        "send_timeout": "5",
        "upstream_host": "$host",
        "xff_header_name": ["X-Forwarded-For"],
        "xrealip_header_name": "X-Real-IP"
      },
      {
        "acao_header": false,
        "client_body_timeout": "5",
        "client_header_timeout": "5",
        "client_max_body_size": "150",
        "client_header_buffer_size": "1",
        "large_client_header_buffers_size": "32",
        "large_client_header_buffers_count": "2",
        "client_body_buffer_size": "4",
        "advanced_configuration": [
          {
            "name": "test-1",
            "description": "",
            "protocol": ["http", "https"],
            "configuration": "code"
          },
          {
            "name": "test-2",
            "description": "",
            "protocol": ["http"],
            "configuration": "code"
          },
          {
            "name": "test-3",
            "description": "",
            "protocol": ["https"],
            "configuration": "code"
          }
        ],
        "custom_listener": false,
        "description": "New Proxy Template description and remarks 111",
        "id": "advanced-config",
        "keepalive_timeout": "660",
        "limit_req_burst": "400",
        "limit_req_rate": "1200",
        "mask_headers": "",
        "name": "Advanced Config Proxy Template",
        "proxy_connect_timeout": "5",
        "proxy_read_timeout": "60",
        "proxy_send_timeout": "30",
        "send_timeout": "5",
        "upstream_host": "$host",
        "xff_header_name": ["X-Forwarded-For"],
        "xrealip_header_name": "X-Real-IP"
      }
    ]
  },
  "purgeCdnCacheProviders": {
    "items": [
      {
        "provider": "gcp"
      },
      {
        "provider": "aws",
        "alternate_domain_names": [
          "test5.cf-test.dev.rbzdns.com",
          "test1.cf-test.dev.rbzdns.com",
          "test4.cf-test.dev.rbzdns.com",
          "test2.cf-test.dev.rbzdns.com",
          "test3.cf-test.dev.rbzdns.com"
        ],
        "distribution_id": "E16QPR6SNV3GX3",
        "name": "Test distribution 123"
      },
      {
        "provider": "aws",
        "alternate_domain_names": [],
        "distribution_id": "E3JYLGFJCGYFC2",
        "name": "E3JYLGFJCGYFC2"
      }
    ]
  },
  "purgeCdnCachePurges": {
    "items": [
      {
        "provider": "gcp",
        "target": {
          "host": "all",
          "path": "all"
        },
        "status": "In-Progress",
        "timestamp": "2024-09-19T09:26:00.000+00:00"
      },
      {
        "provider": "gcp",
        "target": {
          "host": "www.example.com",
          "path": "all"
        },
        "status": "Done",
        "timestamp": "2024-09-19T09:06:00.000+00:00"
      },
      {
        "provider": "gcp",
        "target": {
          "host": "all",
          "path": "/test123"
        },
        "status": "Failed",
        "timestamp": "2024-09-19T09:06:00.000+00:00"
      },
      {
        "provider": "gcp",
        "target": {
          "host": "www.example.com",
          "path": "/test345"
        },
        "status": "Not-Available",
        "timestamp": "2024-09-09T09:06:00.000+00:00"
      },
      {
        "provider": "aws",
        "target": {
          "host": "all",
          "path": "/test1",
          "distribution_id": "E16QPR6SNV3GX3",
          "name": "Test distribution 123"
        },
        "status": "In-Progress",
        "timestamp": "2025-03-20T10:34:21"
      },
      {
        "provider": "aws",
        "target": {
          "host": "all",
          "path": "all",
          "distribution_id": "E16QPR6SNV3GX3",
          "name": "Test distribution 123"
        },
        "status": "Done",
        "timestamp": "2025-03-20T10:34:21"
      },
      {
        "provider": "aws",
        "target": {
          "host": "all",
          "path": "/test2",
          "distribution_id": "E3JYLGFJCGYFC2",
          "name": "test distribution 456"
        },
        "status": "Failed",
        "timestamp": "2025-03-20T10:24:24"
      },
      {
        "provider": "aws",
        "target": {
          "host": "all",
          "path": "/test3",
          "distribution_id": "E3JYLGFJCGYFC2",
          "name": "Test distribution 123"
        },
        "status": "Not-Available",
        "timestamp": "2025-03-20T10:24:01"
      }
    ]
  },
  "quarantinedData": {
    "status": 200,
    "data": {
      "statistics": {},
      "results": [
        {
          "_id": "66e68145047bdc6472234762",
          "config": "prod",
          "target": "ip",
          "value": "176.235.183.110",
          "rule_id": "ca644e0cda95",
          "last_seen": 1726382402,
          "count": 30,
          "tags": ["servergroup:default-site"],
          "timestamp": "2024-09-15T06:40:00",
          "action": "action-monitor"
        },
        {
          "_id": "66e68145047bdc6472234763",
          "config": "prod",
          "target": "ip",
          "value": "176.235.183.111",
          "rule_id": "ca644e0cda95",
          "last_seen": 1726382802,
          "count": 30,
          "tags": ["servergroup:default-site"],
          "timestamp": "2024-09-15T06:45:00",
          "action": "action-monitor"
        },
        {
          "_id": "66e68145047bdc6472234764",
          "config": "prod",
          "target": "ip",
          "value": "176.235.183.112",
          "rule_id": "ca644e0cda95",
          "last_seen": 1726312402,
          "count": 30,
          "tags": ["servergroup:default-site"],
          "timestamp": "2024-09-15T06:50:00",
          "action": "action-monitor"
        },
        {
          "_id": "66e68145047bdc6472234765",
          "config": "prod",
          "target": "ip",
          "value": "176.235.183.113",
          "rule_id": "fake-id",
          "last_seen": null,
          "count": 50,
          "tags": ["servergroup:default-site"],
          "timestamp": "2024-09-15T06:55:00",
          "action": "fake-id"
        },
        {
          "_id": "66e68145047bdc6472234766",
          "config": "prod",
          "target": "ip",
          "value": "192.168.1.100",
          "rule_id": "max-ttl-rule-10years",
          "last_seen": 1726500000,
          "count": 100,
          "tags": ["servergroup:default-site"],
          "timestamp": "2024-09-16T12:00:00",
          "action": "action-monitor"
        }
      ]
    }
  },
  "rateLimitRules": {
    "items": [
      {
        "id": "rl-example",
        "name": "Rate Limit Rule example",
        "description": "Basic example",
        "global": true,
        "active": true,
        "timeframe": 60,
        "threshold": 10000,
        "action": "action-monitor",
        "include": {
          "relation": "OR",
          "tags": []
        },
        "exclude": {
          "relation": "OR",
          "tags": []
        },
        "key": [
          {
            "attrs": "asn"
          },
          {
            "headers": "host"
          },
          {
            "attrs": "path"
          }
        ],
        "pairwith": {
          "self": "self"
        },
        "tags": ["rtc:ddos"]
      },
      {
        "id": "63e2d0837f5f",
        "name": "Rate Limit Rule referenced by Security Policy",
        "description": "New Rate Limit Rule description and remarks.",
        "global": false,
        "active": false,
        "last_activated": 1704008744,
        "timeframe": 60,
        "threshold": 5,
        "action": "rate-limit-block",
        "is_action_ban": false,
        "ttl": 3600,
        "include": {
          "relation": "OR",
          "tags": ["all"]
        },
        "exclude": {
          "relation": "OR",
          "tags": []
        },
        "key": [
          {
            "attrs": "securitypolicyname"
          },
          {
            "attrs": "securitypolicyentryname"
          },
          {
            "attrs": "session"
          }
        ],
        "pairwith": {
          "self": "self"
        },
        "tags": []
      },
      {
        "id": "a3f15c06ee1b",
        "name": "Action Rate Limit Rule",
        "description": "New Rate Limit Rule description and remarks.",
        "global": false,
        "active": false,
        "last_activated": 1704008744,
        "timeframe": 60,
        "threshold": 5,
        "action": "rate-limit-block",
        "is_action_ban": false,
        "ttl": 3600,
        "include": {
          "relation": "OR",
          "tags": ["all"]
        },
        "exclude": {
          "relation": "OR",
          "tags": []
        },
        "key": [
          {
            "attrs": "securitypolicyname"
          },
          {
            "attrs": "securitypolicyentryname"
          },
          {
            "attrs": "session"
          }
        ],
        "pairwith": {
          "self": "self"
        },
        "tags": []
      },
      {
        "id": "a282167706ba",
        "name": "Delete Rate Limit Rule",
        "description": "New Rate Limit Rule description and remarks.",
        "global": false,
        "active": false,
        "last_activated": 1704008744,
        "timeframe": 60,
        "threshold": 5,
        "action": "action-monitor",
        "is_action_ban": true,
        "ttl": 3600,
        "include": {
          "relation": "OR",
          "tags": ["all"]
        },
        "exclude": {
          "relation": "OR",
          "tags": []
        },
        "key": [
          {
            "attrs": "securitypolicyname"
          },
          {
            "attrs": "securitypolicyentryname"
          },
          {
            "attrs": "session"
          }
        ],
        "pairwith": {
          "attrs": "ip"
        },
        "tags": []
      },
      {
        "id": "7ce27ec572af",
        "name": "Unconnected Rate Limit Rule",
        "description": "Basic example that is not connected to any Security Policy",
        "global": true,
        "active": true,
        "timeframe": 60,
        "threshold": 10000,
        "action": "action-monitor",
        "include": {
          "relation": "OR",
          "tags": []
        },
        "exclude": {
          "relation": "OR",
          "tags": []
        },
        "key": [
          {
            "attrs": "asn"
          },
          {
            "headers": "host"
          },
          {
            "attrs": "path"
          }
        ],
        "pairwith": {
          "self": "self"
        },
        "tags": ["rtc:ddos"]
      }
    ]
  },
  "securityAlerts": {
    "items": [
      {
        "id": "950dc384ada2",
        "name": "mock security alert 1",
        "server_groups": ["__default__", "3ae72c36d2e2"],
        "dynamic_rules": ["b40b596e6710", "5ec50da4f5ef"],
        "recipients": ["email1@example.com", "email2@example.com", "email3@example.com"]
      },
      {
        "id": "92d385b2b15e",
        "name": "mock security alert 2",
        "server_groups": ["__default__", "3ae72c36d2e2"],
        "dynamic_rules": ["5ec50da4f5ef", "b40b596e6710"],
        "recipients": ["email5@example.com", "email6@example.com", "email7@example.com"]
      },
      {
        "id": "fb8d3ef83d32",
        "name": "security alert to delete",
        "server_groups": ["b0d95a371e99"],
        "dynamic_rules": ["5ec50da4f5ef"],
        "recipients": ["email6@example.com"]
      }
    ]
  },
  "securityPolicies": {
    "items": [
      {
        "id": "__default__",
        "description": "bla",
        "name": "default security policy",
        "tags": ["api"],
        "match": "__default__",
        "session": [
          {
            "attrs": "ip"
          }
        ],
        "session_ids": [
          {
            "header": "foo"
          }
        ],
        "map": [
          {
            "id": "__root_entry__",
            "name": "__root__",
            "match": "^/(\\W.*)?$",
            "acl_profile": "__acldefault__",
            "acl_profile_active": true,
            "backend_service": "__default__",
            "edge_functions": ["__default__"],
            "content_filter_profile": "__defaultcontentfilter__",
            "content_filter_profile_active": true,
            "rate_limit_rules": ["rl-example"]
          },
          {
            "id": "__default_entry__",
            "name": "__default__",
            "match": "/",
            "acl_profile": "__acldefault__",
            "acl_profile_active": true,
            "backend_service": "__default__",
            "edge_functions": [],
            "content_filter_profile": "__defaultcontentfilter__",
            "content_filter_profile_active": true,
            "rate_limit_rules": []
          },
          {
            "id": "__site_level__",
            "name": "Site Level",
            "match": "__site_level__",
            "acl_profile": "__acldefault__",
            "acl_profile_active": false,
            "backend_service": "__default__",
            "edge_functions": [],
            "content_filter_profile": "__defaultcontentfilter__",
            "content_filter_profile_active": false,
            "rate_limit_rules": []
          }
        ]
      },
      {
        "id": "e189f60a6489",
        "name": "Referencing others security policy",
        "description": "",
        "tags": [],
        "match": "__default__",
        "session": [
          {
            "attrs": "ip"
          }
        ],
        "map": [
          {
            "id": "__default_entry__",
            "name": "__default__",
            "match": "/",
            "acl_profile": "d16fd217e6b9",
            "acl_profile_active": true,
            "backend_service": "6f6295de664f",
            "edge_functions": ["f971e92459e2"],
            "content_filter_profile": "f4dbffdf8ecc",
            "content_filter_profile_active": true,
            "rate_limit_rules": ["63e2d0837f5f"]
          },
          {
            "id": "__site_level__",
            "name": "Site Level",
            "match": "__site_level__",
            "acl_profile": "__acldefault__",
            "acl_profile_active": false,
            "backend_service": "__default__",
            "edge_functions": [],
            "content_filter_profile": "__defaultcontentfilter__",
            "content_filter_profile_active": false,
            "rate_limit_rules": []
          }
        ]
      },
      {
        "id": "7c474581ac57",
        "name": "Security Policy referenced by Server Group",
        "description": "",
        "tags": [],
        "match": "__default__",
        "session": [
          {
            "attrs": "ip"
          }
        ],
        "map": [
          {
            "id": "blabla",
            "name": "__root__",
            "match": "^/(\\W.*)?$",
            "acl_profile": "__acldefault__",
            "acl_profile_active": true,
            "backend_service": "__default__",
            "edge_functions": [],
            "content_filter_profile": "__defaultcontentfilter__",
            "content_filter_profile_active": true,
            "rate_limit_rules": []
          },
          {
            "id": "__site_level__",
            "name": "Site Level",
            "match": "__site_level__",
            "acl_profile": "__acldefault__",
            "acl_profile_active": false,
            "backend_service": "__default__",
            "edge_functions": [],
            "content_filter_profile": "__defaultcontentfilter__",
            "content_filter_profile_active": false,
            "rate_limit_rules": []
          }
        ]
      },
      {
        "id": "e04381618cc4",
        "name": "Delete Security Policy",
        "description": "",
        "tags": [],
        "match": "__default__",
        "session": [
          {
            "attrs": "ip"
          }
        ],
        "map": [
          {
            "id": "__root_entry__",
            "name": "__root__",
            "match": "^/(\\W.*)?$",
            "acl_profile": "__acldefault__",
            "acl_profile_active": true,
            "backend_service": "__default__",
            "edge_functions": [],
            "content_filter_profile": "__defaultcontentfilter__",
            "content_filter_profile_active": true,
            "rate_limit_rules": []
          },
          {
            "id": "__default_entry__",
            "name": "__default__",
            "match": "/",
            "acl_profile": "__acldefault__",
            "acl_profile_active": true,
            "backend_service": "__default__",
            "edge_functions": [],
            "content_filter_profile": "__defaultcontentfilter__",
            "content_filter_profile_active": true,
            "rate_limit_rules": []
          },
          {
            "id": "__site_level__",
            "name": "Site Level",
            "match": "__site_level__",
            "acl_profile": "__acldefault__",
            "acl_profile_active": false,
            "backend_service": "__default__",
            "edge_functions": [],
            "content_filter_profile": "__defaultcontentfilter__",
            "content_filter_profile_active": false,
            "rate_limit_rules": []
          }
        ]
      },
      {
        "id": "c6c3eac323e8",
        "name": "Security Policy with empty map",
        "description": "",
        "tags": [],
        "match": "__default__",
        "session": [
          {
            "attrs": "ip"
          }
        ],
        "map": []
      },
      {
        "id": "2700ab6ab97d",
        "name": "Security Policy with no map",
        "description": "",
        "tags": [],
        "match": "__default__",
        "session": [
          {
            "attrs": "ip"
          }
        ]
      },
      {
        "id": "edit",
        "name": "copy of default entry",
        "description": "",
        "match": "www.example.com",
        "session": [
          {
            "attrs": "ip"
          }
        ],
        "map": [
          {
            "id": "__root_entry__",
            "name": "__root__",
            "match": "^/(\\W.*)?$",
            "acl_profile": "__acldefault__",
            "acl_profile_active": true,
            "backend_service": "__default__",
            "edge_functions": [],
            "content_filter_profile": "__defaultcontentfilter__",
            "content_filter_profile_active": true,
            "rate_limit_rules": []
          },
          {
            "id": "__default_entry__",
            "name": "__default__",
            "match": "/",
            "acl_profile": "__acldefault__",
            "acl_profile_active": true,
            "backend_service": "__default__",
            "edge_functions": [],
            "content_filter_profile": "__defaultcontentfilter__",
            "content_filter_profile_active": true,
            "rate_limit_rules": []
          },
          {
            "id": "__site_level__",
            "name": "Site Level",
            "match": "__site_level__",
            "acl_profile": "__acldefault__",
            "acl_profile_active": false,
            "backend_service": "__default__",
            "edge_functions": [],
            "content_filter_profile": "__defaultcontentfilter__",
            "content_filter_profile_active": false,
            "rate_limit_rules": []
          }
        ]
      }
    ]
  },
  "serverGroups": {
    "items": [
      {
        "id": "__default__",
        "mobile_application_group": "__default__",
        "description": "",
        "challenge_cookie_domain": "$host",
        "name": "default.site",
        "proxy_template": "__default__",
        "routing_profile": "__default__",
        "security_policy": "__default__",
        "server_names": ["default.site", "example.com"],
        "ssl_certificate": "placeholder",
        "client_certificate": "placeholder",
        "client_certificate_mode": "on",
        "map": [
          {
            "id": "__root_entry__",
            "name": "__root__",
            "match": "^/(\\W.*)?$"
          }
        ],
        "crl_verify": true,
        "crl": []
      },
      {
        "description": "New Server Group description and remarks.",
        "id": "3ae72c36d2e2",
        "mobile_application_group": "d8bb3d912af6",
        "challenge_cookie_domain": "$host",
        "name": "Referencing others Server Group",
        "proxy_template": "3aed9031176d",
        "routing_profile": "__default__",
        "security_policy": "7c474581ac57",
        "server_names": ["www.example.com"],
        "ssl_certificate": "placeholder",
        "client_certificate": "",
        "client_certificate_mode": "off",
        "map": [
          {
            "id": "__root_entry__",
            "name": "__root__",
            "match": "^/(\\W.*)?$"
          }
        ],
        "crl_verify": false,
        "crl": []
      },
      {
        "id": "b0d95a371e99",
        "mobile_application_group": "__default__",
        "challenge_cookie_domain": "$host",
        "name": "Delete Server Group",
        "description": "",
        "proxy_template": "__default__",
        "routing_profile": "__default__",
        "security_policy": "__default__",
        "server_names": ["default.site"],
        "ssl_certificate": "d8ad5b1156c0",
        "client_certificate": "a033327cd8e5",
        "crl_verify": false,
        "crl": []
      },
      {
        "id": "b0d95a371e92",
        "mobile_application_group": "",
        "challenge_cookie_domain": "$host",
        "name": "Delete Server Group",
        "proxy_template": "__default__",
        "routing_profile": "__default__",
        "security_policy": "__default__",
        "server_names": ["default.site"],
        "ssl_certificate": "16a0c52d56bd",
        "client_certificate": "16a0c52d56bd",
        "crl_verify": false,
        "crl": []
      },
      {
        "description": "New Server Group description and remarks.",
        "id": "ce675306bbd2",
        "mobile_application_group": "non-existing-id",
        "challenge_cookie_domain": "$host",
        "name": "Referencing non-existing entities Server Group",
        "proxy_template": "non-existing-id",
        "routing_profile": "non-existing-id",
        "security_policy": "non-existing-id",
        "server_names": ["www.example.com"],
        "ssl_certificate": "placeholder",
        "client_certificate": "placeholder",
        "crl_verify": true,
        "crl": [],
        "crl_statuses": [
          {
            "url": "https://www.example1.com/crl.pem",
            "issuer": "Example Inc. 1",
            "last_update": "2021-01-01",
            "last_download": "2021-01-01",
            "last_check": "2021-01-01",
            "status": true
          },
          {
            "url": "https://www.example2.com/crl.pem",
            "issuer": "Example Inc. 2",
            "last_update": "2021-02-01",
            "last_download": "2021-02-01",
            "last_check": "2021-02-01",
            "status": true
          },
          {
            "url": "https://www.example3.com/crl.pem",
            "issuer": "Example Inc. 3",
            "last_update": "2021-03-01",
            "last_download": "2021-03-01",
            "last_check": "2021-03-01",
            "status": false,
            "error": "Failed to download CRL: connection timeout"
          }
        ]
      }
    ]
  },
  "versions": {
    "planet": "v5.3.18-rc-04",
    "api_version": "v4.2",
    "nlb": true,
    "cert_download_enabled": true
  },
  "certificates": {
    "items": [
      {
        "cert_body": "-----BEGIN CERTIFICATE-----\ntest-cert-1\n-----END CERTIFICATE-----\n",
        "exp_date": "2027-06-09",
        "id": "placeholder",
        "issuer": "C=US, ST=New York, O=Kramerica Industries, L=New York, CN=kramericaindustries.kramericaindustries",
        "le_auto_renew": false,
        "le_auto_replace": false,
        "le_hash": "",
        "provider_links": [
          {
            "link": "arn:aws:acm:eu-west-1:588266063552:certificate/e2d3af86-60b7-4d46-a3d2-5b6b1f7b0323",
            "provider": "aws",
            "region": "eu-west-1"
          }
        ],
        "name": "test-certificate-name-1",
        "san": ["fire-asd.rbzfakeohbs.dev.rbzdns.com"],
        "subject": "C=US, ST=New York, O=Kramerica Industries, L=New York, CN=kramericaindustries.kramericaindustries",
        "upload_time": "2022-10-20 17:21:46.982976",
        "side": "server",
        "revoked": false
      },
      {
        "cert_body": "-----BEGIN CERTIFICATE-----\ntest-cert-2\n-----END CERTIFICATE-----\n",
        "exp_date": "2023-02-22",
        "id": "d8ad5b1156c0",
        "issuer": "C=US, O=Let\"s Encrypt, CN=R3",
        "le_auto_renew": false,
        "le_auto_replace": false,
        "le_hash": "",
        "provider_links": [
          {
            "link": "arn:aws:acm:eu-west-1:588266063552:certificate/4230b7f1-b6b5-2d3a-64d4-7b0668fa3d2e",
            "provider": "aws",
            "region": "eu-west-1"
          }
        ],
        "name": "test-certificate-name-2",
        "san": ["www.example.com"],
        "subject": "CN=test-com.rbzdevsaforb.dev.rbzdns.com",
        "upload_time": "2022-11-28 12:28:24.819755",
        "side": "server",
        "revoked": false
      },
      {
        "cert_body": "-----BEGIN CERTIFICATE-----\ntest-cert-3\n-----END CERTIFICATE-----\n",
        "exp_date": "2023-02-26",
        "id": "16a0c52d56bd",
        "issuer": "C=US, O=Let\"s Encrypt, CN=R3",
        "le_auto_renew": false,
        "le_auto_replace": false,
        "le_hash": "56d7fd3d7d8346bf9b027221ec97bd08",
        "provider_links": [
          {
            "link": "fake-gcp-link:eu-west-1:2451251355:certificate/0103ab0b-b6f0-ab5f-ad01-b76a5f7b0412",
            "provider": "gcp",
            "region": "eu-west-1"
          }
        ],
        "name": "test-certificate-name-3",
        "san": ["fire-asd.rbzfakeohbs.dev.rbzdns.com"],
        "subject": "CN=fire-asd.rbzfakeohbs.dev.rbzdns.com",
        "upload_time": "2022-11-28",
        "side": "server",
        "revoked": false
      },
      {
        "cert_body": "-----BEGIN CERTIFICATE-----\ntest-cert-4\n-----END CERTIFICATE-----\n",
        "exp_date": "2023-02-26",
        "id": "db65d25c0a61",
        "issuer": "C=US, O=Let\"s Encrypt, CN=R3",
        "le_auto_renew": false,
        "le_auto_replace": false,
        "le_hash": "56d7fd3d7d8346bf9b027221ec97bd08",
        "provider_links": [],
        "name": "test-certificate-name-4",
        "san": ["fire-asd.rbzfakeohbs.dev.rbzdns.com"],
        "subject": "CN=fire-asd.rbzfakeohbs.dev.rbzdns.com",
        "upload_time": "2022-11-28",
        "side": "server",
        "revoked": false
      },
      {
        "cert_body": "-----BEGIN CERTIFICATE-----\ntest-cert-1\n-----END CERTIFICATE-----\n",
        "exp_date": "2027-06-09",
        "description": "",
        "id": "placeholder",
        "issuer": "C=US, ST=New York, O=Kramerica Industries, L=New York, CN=kramericaindustries.kramericaindustries",
        "name": "test-certificate-name-1",
        "san": ["fire-asd.rbzfakeohbs.dev.rbzdns.com"],
        "subject": "C=US, ST=New York, O=Kramerica Industries, L=New York, CN=kramericaindustries.kramericaindustries",
        "upload_time": "2022-10-20 17:21:46.982976",
        "side": "clientCA",
        "revoked": false
      },
      {
        "cert_body": "-----BEGIN CERTIFICATE-----\ntest-cert-2\n-----END CERTIFICATE-----\n",
        "exp_date": "2023-02-22",
        "description": "",
        "id": "a033327cd8e5",
        "issuer": "C=US, O=Let\"s Encrypt, CN=R3",
        "name": "test-certificate-name-2",
        "san": ["www.example.com"],
        "subject": "CN=test-com.rbzdevsaforb.dev.rbzdns.com",
        "upload_time": "2022-11-28 12:28:24.819755",
        "side": "clientCA",
        "revoked": false
      },
      {
        "cert_body": "-----BEGIN CERTIFICATE-----\ntest-cert-3\n-----END CERTIFICATE-----\n",
        "exp_date": "2023-02-26",
        "description": "",
        "id": "16a0c52d56bd",
        "issuer": "C=US, O=Let\"s Encrypt, CN=R3",
        "name": "test-certificate-name-3",
        "san": ["fire-asd.rbzfakeohbs.dev.rbzdns.com"],
        "subject": "CN=fire-asd.rbzfakeohbs.dev.rbzdns.com",
        "upload_time": "2022-11-28",
        "side": "clientCA",
        "revoked": false
      },
      {
        "cert_body": "-----BEGIN CERTIFICATE-----\ntest-cert-1\n-----END CERTIFICATE-----\n",
        "exp_date": "2027-06-09",
        "id": "3140fe92",
        "issuer": "C=US, ST=New York, O=Kramerica Industries, L=New York, CN=kramericaindustries.kramericaindustries",
        "le_auto_renew": false,
        "le_auto_replace": false,
        "le_hash": "",
        "provider_links": [
          {
            "link": "arn:aws:acm:eu-west-1:588266063552:certificate/e2d3af86-60b7-4d46-a3d2-5b6b1f7b0323",
            "provider": "aws",
            "region": "eu-west-1"
          }
        ],
        "name": "test-server-to-backend-mtls-certificate-name-1",
        "san": ["fire-asd.rbzfakeohbs.dev.rbzdns.com"],
        "subject": "C=US, ST=New York, O=Kramerica Industries, L=New York, CN=kramericaindustries.kramericaindustries",
        "upload_time": "2022-10-20 17:21:46.982976",
        "side": "serverToBackendMTLS",
        "revoked": false
      },
      {
        "cert_body": "-----BEGIN CERTIFICATE-----\ntest-cert-1\n-----END CERTIFICATE-----\n",
        "exp_date": "2027-06-09",
        "id": "134090fbca3",
        "issuer": "C=US, ST=New York, O=Kramerica Industries, L=New York, CN=kramericaindustries.kramericaindustries",
        "le_auto_renew": false,
        "le_auto_replace": false,
        "le_hash": "",
        "provider_links": [
          {
            "link": "arn:aws:acm:eu-west-1:588266063552:certificate/e2d3af86-60b7-4d46-a3d2-5b6b1f7b0323",
            "provider": "aws",
            "region": "eu-west-1"
          }
        ],
        "name": "test-server-to-backend-mtls-certificate-name-2",
        "san": ["fire-asd.rbzfakeohbs.dev.rbzdns.com"],
        "subject": "C=US, ST=New York, O=Kramerica Industries, L=New York, CN=kramericaindustries.kramericaindustries",
        "upload_time": "2022-10-20 17:21:46.982976",
        "side": "serverToBackendMTLS",
        "revoked": false
      },
      {
        "cert_body": "-----BEGIN CERTIFICATE-----\ntest-cert-1\n-----END CERTIFICATE-----\n",
        "exp_date": "2027-06-09",
        "id": "a768ce6ea468",
        "issuer": "C=US, ST=New York, O=Kramerica Industries, L=New York, CN=kramericaindustries.kramericaindustries",
        "le_auto_renew": false,
        "le_auto_replace": false,
        "le_hash": "",
        "provider_links": [
          {
            "link": "arn:aws:acm:eu-west-1:588266063552:certificate/e2d3af86-60b7-4d46-a3d2-5b6b1f7b0323",
            "provider": "aws",
            "region": "eu-west-1"
          }
        ],
        "name": "test-server-to-backend-mtls-certificate-name-3",
        "san": ["fire-asd.rbzfakeohbs.dev.rbzdns.com"],
        "subject": "C=US, ST=New York, O=Kramerica Industries, L=New York, CN=kramericaindustries.kramericaindustries",
        "upload_time": "2022-10-20 17:21:46.982976",
        "side": "serverToBackendMTLS",
        "revoked": false
      },
      {
        "cert_body": "-----BEGIN CERTIFICATE-----\ntest-cert-1\n-----END CERTIFICATE-----\n",
        "exp_date": "2027-06-09",
        "id": "b34e77ad777c",
        "issuer": "C=US, ST=New York, O=Kramerica Industries, L=New York, CN=kramericaindustries.kramericaindustries",
        "le_auto_renew": false,
        "le_auto_replace": false,
        "le_hash": "",
        "provider_links": [],
        "name": "test-server-to-backend-ca-certificate-name-1",
        "san": ["fire-asd.rbzfakeohbs.dev.rbzdns.com"],
        "subject": "C=US, ST=New York, O=Kramerica Industries, L=New York, CN=kramericaindustries.kramericaindustries",
        "upload_time": "2022-10-20 17:21:46.982976",
        "side": "backendCA",
        "revoked": false
      },
      {
        "cert_body": "-----BEGIN CERTIFICATE-----\ntest-cert-1\n-----END CERTIFICATE-----\n",
        "exp_date": "2027-06-09",
        "id": "8e133df15ea7",
        "issuer": "C=US, ST=New York, O=Kramerica Industries, L=New York, CN=kramericaindustries.kramericaindustries",
        "le_auto_renew": false,
        "le_auto_replace": false,
        "le_hash": "",
        "provider_links": [],
        "name": "test-server-to-backend-ca-certificate-name-2",
        "san": ["fire-asd.rbzfakeohbs.dev.rbzdns.com"],
        "subject": "C=US, ST=New York, O=Kramerica Industries, L=New York, CN=kramericaindustries.kramericaindustries",
        "upload_time": "2022-10-20 17:21:46.982976",
        "side": "backendCA",
        "revoked": false
      }
    ]
  },
  "sslLoadBalancers": {
    "items": [
      {
        "certificates": [
          "arn:aws:acm:eu-west-1:588266063552:certificate/e2d3af86-60b7-4d46-a3d2-5b6b1f7b0323"
        ],
        "default_certificate": "fake-gcp-link:eu-west-1:2451251355:certificate/0103ab0b-b6f0-ab5f-ad01-b76a5f7b0412",
        "dns_name": "rbzfake-prod-alb-784708966.eu-west-1.elb.amazonaws.com",
        "elb_version": 2,
        "hosted_zoned_id": "Z32O12XQLNTSW2",
        "listener_name": "Listener-name-1",
        "listener_port": 1,
        "load_balancer_type": "application",
        "name": "test-balancer-name-1",
        "provider": "gcp",
        "region": "eu-west-1"
      },
      {
        "certificates": [
          "arn:aws:acm:eu-west-1:588266063552:certificate/e2d3af86-60b7-4d46-a3d2-5b6b1f7b0323",
          "arn:aws:acm:eu-west-1:588266063552:certificate/4230b7f1-b6b5-2d3a-64d4-7b0668fa3d2e"
        ],
        "default_certificate": "fake-gcp-link:eu-west-1:2451251355:certificate/0103ab0b-b6f0-ab5f-ad01-b76a5f7b0412",
        "dns_name": "rbzfake-prod-alb-784708966.eu-west-1.elb.amazonaws.com",
        "elb_version": 2,
        "hosted_zoned_id": "Z32O12XQLNTSW2",
        "listener_name": "Listener-name-2",
        "listener_port": 2,
        "load_balancer_type": "application",
        "name": "test-balancer-name-2",
        "provider": "aws",
        "region": "eu-west-1"
      },
      {
        "certificates": [],
        "default_certificate": "arn:aws:acm:eu-west-1:588266063552:certificate/e2d3af86-60b7-4d46-a3d2-5b6b1f7b0323",
        "dns_name": "rbzfake-stage-alb-242899288.eu-west-1.elb.amazonaws.com",
        "elb_version": 2,
        "hosted_zoned_id": "Z32O12XQLNTSW2",
        "listener_name": "Listener-name-3",
        "listener_port": 3,
        "load_balancer_type": "classic",
        "name": "test-balancer-name-3",
        "provider": "aws",
        "region": "eu-west-1"
      },
      {
        "certificates": [],
        "default_certificate": "arn:aws:acm:eu-west-1:588266063552:certificate/e2d3af86-60b7-4d46-a3d2-5b6b1f7b0323",
        "dns_name": "rbzfake-stage-alb-242899288.eu-west-1.elb.amazonaws.com",
        "elb_version": 2,
        "hosted_zoned_id": "Z32O12XQLNTSW2",
        "listener_name": "Listener-name-3",
        "listener_port": 3,
        "load_balancer_type": "application",
        "name": "test-balancer-name-4",
        "provider": "azure",
        "region": "eu-west-1"
      },
      {
        "certificates": [
          "https://www.googleapis.com/compute/v1/projects/rbz-dev-002/global/sslCertificates/placeholder-certificate"
        ],
        "default_certificate": "arn:aws:acm:eu-west-1:588266063552:certificate/e2d3af86-60b7-4d46-a3d2-5b6b1f7b0323",
        "dns_name": "rbzfake-stage-alb-242899288.eu-west-1.elb.amazonaws.com",
        "elb_version": 2,
        "hosted_zoned_id": "Z32O12XQLNTSW2",
        "listener_name": "Listener-name-3",
        "listener_port": 3,
        "load_balancer_type": "application",
        "name": "test-balancer-name-5",
        "provider": "gcp",
        "region": "eu-west-1"
      },
      {
        "default_certificate": "arn:aws:acm:eu-west-1:588266063552:certificate/e2d3af86-60b7-4d46-a3d2-5b6b1f7b0323",
        "dns_name": "rbzfake-stage-alb-242899288.eu-west-1.elb.amazonaws.com",
        "elb_version": 2,
        "hosted_zoned_id": "Z32O12XQLNTSW2",
        "listener_name": "Listener-name-3",
        "listener_port": 3,
        "load_balancer_type": "application",
        "name": "test-balancer-name-6",
        "provider": "gcp",
        "region": "eu-west-1"
      },
      {
        "certificates": ["link11:certificate:12345678-abcd-1234-abcd-123456789abc"],
        "default_certificate": "link11:certificate:87654321-dcba-4321-dcba-cba987654321",
        "dns_name": "link11-lb.example.com",
        "elb_version": 2,
        "hosted_zoned_id": "LINK11ZONE",
        "listener_name": "Listener-name-7",
        "listener_port": 443,
        "load_balancer_type": "link11",
        "name": "test-balancer-name-7",
        "provider": "link11",
        "region": "eu-central-1"
      }
    ]
  },
  "sslLoadBalancersRegions": {
    "lbs": {
      "4090": {
        "id": "4090",
        "name": "test-balancer-name-1",
        "upstream_regions": ["ffm"],
        "regions": {
          "ffm": "automatic",
          "ash": "automatic",
          "lon": "automatic",
          "stl": "automatic",
          "hkg": "automatic",
          "lax": "automatic",
          "sgp": "ffm"
        }
      },
      "4089": {
        "id": "4089",
        "name": "test-balancer-name-2",
        "upstream_regions": ["ffm"],
        "regions": {
          "ffm": "automatic",
          "ash": "automatic",
          "lon": "automatic",
          "stl": "automatic",
          "hkg": "automatic",
          "lax": "automatic",
          "sgp": "automatic"
        }
      },
      "4088": {
        "id": "4088",
        "name": "test-balancer-name-3",
        "upstream_regions": ["ffm"],
        "regions": {
          "ffm": "automatic",
          "ash": "automatic",
          "lon": "automatic",
          "stl": "automatic",
          "hkg": "automatic",
          "lax": "automatic",
          "sgp": "automatic"
        }
      },
      "4087": {
        "id": "4087",
        "name": "test-balancer-name-4",
        "upstream_regions": ["ffm"],
        "regions": {
          "ffm": "automatic",
          "ash": "automatic",
          "lon": "automatic",
          "stl": "automatic",
          "hkg": "automatic",
          "lax": "automatic",
          "sgp": "automatic"
        }
      },
      "4086": {
        "id": "4086",
        "name": "test-balancer-name-5",
        "upstream_regions": ["ffm"],
        "regions": {
          "ffm": "automatic",
          "ash": "automatic",
          "lon": "automatic",
          "stl": "automatic",
          "hkg": "automatic",
          "lax": "automatic",
          "sgp": "automatic"
        }
      },
      "4085": {
        "id": "4085",
        "name": "test-balancer-name-6",
        "upstream_regions": ["ffm"],
        "regions": {
          "ffm": "automatic",
          "ash": "automatic",
          "lon": "automatic",
          "stl": "automatic",
          "hkg": "automatic",
          "lax": "automatic",
          "sgp": "automatic"
        }
      }
    },
    "city_codes": {
      "ffm": "Frankfurt",
      "ash": "Ashburn",
      "lon": "London",
      "stl": "Saint Louis",
      "hkg": "Hong Kong",
      "lax": "Los Angeles",
      "sgp": "Singapore"
    }
  },
  "ssoConfiguration": {
    "enabled": true,
    "title": "Test",
    "provider": "okta",
    "protocol": "oauth2",
    "params": {
      "roles_claim_key": "id",
      "roles": [
        {
          "idp_group": "",
          "waap_groups": ["waap-config-viewer"]
        }
      ],
      "token_expiration_threshold": 600,
      "client_id": "1234567abcdef",
      "client_secret": "shush",
      "issuer": "self"
    }
  },
  "usersManagement": {
    "items": [
      {
        "name": "100000000000000000000000",
        "id": "Link11 default organization",
        "users": [
          {
            "id": "org1admin",
            "acl": "acl",
            "contact_name": "John Doe org admin",
            "mobile": "+972520000000",
            "email": "fake+orgadmin@link11.com",
            "org_id": "100000000000000000000000",
            "org_name": "Link11 default organization"
          },
          {
            "id": "user_id_2",
            "acl": "editor",
            "mobile": "+1234567890",
            "contact_name": "John Doe org editor",
            "email": "user_2@org1.com",
            "org_id": "org_1",
            "org_name": "organization_1"
          }
        ]
      },
      {
        "name": "organization_2",
        "id": "org_2",
        "users": [
          {
            "id": "user_id_3",
            "acl": "admin",
            "mobile": "+1234567890",
            "contact_name": "user org admin",
            "email": "user_3@org2.com",
            "org_id": "org_2",
            "org_name": "organization_2"
          },
          {
            "id": "user_id_4",
            "acl": "editor",
            "mobile": "+1234567890",
            "contact_name": "user org editor",
            "email": "user4@org2.com",
            "org_id": "org_2",
            "org_name": "organization_2"
          }
        ]
      }
    ]
  },
  "aiCrawlers": [
    {
      "name": "ChatGPT",
      "totalRequests": "2.3K",
      "allowedToPass": "244.35",
      "blocked": 147
    },
    {
      "name": "Perplexity",
      "totalRequests": "6.3K",
      "allowedToPass": "244.35",
      "blocked": 4
    },
    {
      "name": "Claude AI",
      "totalRequests": "1.3K",
      "allowedToPass": "244.35",
      "blocked": 2
    },
    {
      "name": "Bing AI",
      "totalRequests": "1.4K",
      "allowedToPass": "244.35",
      "blocked": 2
    }
  ]
}
